var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/devices/s330/s330-config.ts
var S330_ADDRESSES = {
  /** System parameters base address */
  system: [0, 0, 0, 0],
  /** Patch parameters base address */
  patchBase: [0, 0, 0, 0],
  /** Tone parameters base address */
  toneBase: [0, 3, 0, 0],
  /** Wave data base address */
  waveData: [1, 0, 0, 0]
};
var S330_CONFIG = {
  modelId: 30,
  deviceName: "S-330",
  // Memory layout
  patchCount: 64,
  toneCount: 32,
  waveBankCount: 2,
  // Value ranges
  maxToneIndex: 31,
  maxWaveBank: 1,
  maxPatchIndex: 63,
  // Address constants
  addresses: S330_ADDRESSES,
  // Block sizes
  patchBlockSize: 512,
  toneBlockSize: 256,
  patchBlockNibbles: 1024,
  toneBlockNibbles: 512,
  toneStride: 2,
  toneMapEntries: 109
};

// src/devices/roland-s-series/s-series-types.ts
function sampleRateLabelToHz(rate) {
  return rate === "30kHz" ? 3e4 : 15e3;
}
function toneSampleRateHz(tone) {
  return sampleRateLabelToHz(tone.sampleRate);
}

// src/devices/roland-s-series/s-series-constants.ts
var ROLAND_ID = 65;
var S_SERIES_MODEL_ID = 30;
var DEFAULT_DEVICE_ID = 0;
var S_SERIES_COMMANDS = {
  /** Data Request (host to device) */
  RQ1: 17,
  /** Data Set (host to device) */
  DT1: 18,
  /** Want to Send Data (bulk dump initiate) */
  WSD: 64,
  /** Request Data (bulk dump request) */
  RQD: 65,
  /** Data Transfer (bulk dump packet) */
  DAT: 66,
  /** Acknowledge */
  ACK: 67,
  /** End of Data */
  EOD: 69,
  /** Communication Error */
  ERR: 78,
  /** Rejection */
  RJC: 79
};
var ERROR_CODES = {
  CHECKSUM: 0,
  UNKNOWN_COMMAND: 1,
  WRONG_FORMAT: 2,
  MEMORY_FULL: 3,
  OUT_OF_RANGE: 4
};
var TIMING = {
  /** Minimum inter-byte delay in ms */
  INTER_BYTE_DELAY_MS: 1,
  /** ACK response timeout in ms */
  ACK_TIMEOUT_MS: 500,
  /** Retry delay after error in ms */
  RETRY_DELAY_MS: 100,
  /** Maximum retry attempts */
  MAX_RETRIES: 3,
  /** Maximum bytes per DAT packet */
  MAX_PACKET_SIZE: 256
};
var VALUE_RANGES = {
  /** Device ID range */
  DEVICE_ID: { min: 0, max: 31 },
  /** MIDI channel range */
  MIDI_CHANNEL: { min: 0, max: 15 },
  /** Pitch bend range (semitones) */
  BENDER_RANGE: { min: 0, max: 12 },
  /** Standard 7-bit parameter */
  STANDARD_7BIT: { min: 0, max: 127 }
};
var BULK_DUMP_TYPES = {
  ALL_PATCHES: 0,
  ALL_TONES: 1,
  SINGLE_PATCH: 2,
  SINGLE_TONE: 3,
  WAVE_DATA: 4,
  ALL_DATA: 127
};

// src/devices/roland-s-series/s-series-device-limits.ts
var S330_DEVICE_LIMITS = {
  sourcetoneMask: 31,
  waveBankMask: 1,
  copySourceMask: 31,
  maxPatchNumber: 63,
  maxToneNumber: 31
};

// src/devices/roland-s-series/s-series-addresses.ts
var PATCH_COMMON_OFFSETS = {
  NAME: 0,
  // 12 bytes
  BENDER_RANGE: 12,
  AFTERTOUCH_SENS: 14,
  KEY_MODE: 15,
  VELOCITY_THRESHOLD: 16,
  TONE_LAYER_1: 17,
  // 109 entries
  TONE_LAYER_2: 126,
  // 109 entries
  COPY_SOURCE: 235,
  OCTAVE_SHIFT: 284,
  LEVEL: 285,
  DETUNE: 287,
  VELOCITY_MIX_RATIO: 288,
  AFTERTOUCH_ASSIGN: 289,
  KEY_ASSIGN: 290,
  OUTPUT_ASSIGN: 291
};
var PATCH_TOTAL_SIZE = 512;
var PATCH_PARAMS = {
  name: {
    name: "Name",
    address: [0, 0],
    byteOffset: 0,
    size: 12
  },
  benderRange: {
    name: "Bender Range",
    address: [0, 24],
    byteOffset: 12,
    size: 1
  },
  aftertouchSens: {
    name: "A.T. Sensitivity",
    address: [0, 28],
    byteOffset: 14,
    size: 1
  },
  keyMode: {
    name: "Key Mode",
    address: [0, 30],
    byteOffset: 15,
    size: 1
  },
  velocityThreshold: {
    name: "V-Sw Threshold",
    address: [0, 32],
    byteOffset: 16,
    size: 1
  },
  toneLayer1: {
    name: "Tone Layer 1",
    address: [0, 34],
    byteOffset: 17,
    size: 109
  },
  toneLayer2: {
    name: "Tone Layer 2",
    address: [1, 124],
    byteOffset: 126,
    size: 109
  },
  copySource: {
    name: "Copy Source",
    address: [3, 86],
    byteOffset: 235,
    size: 1
  },
  octaveShift: {
    name: "Octave Shift",
    address: [3, 88],
    byteOffset: 236,
    size: 1
  },
  level: {
    name: "Level",
    address: [3, 90],
    byteOffset: 237,
    size: 1
  },
  detune: {
    name: "Detune",
    address: [3, 94],
    byteOffset: 239,
    size: 1
  },
  velocityMixRatio: {
    name: "V-Mix Ratio",
    address: [3, 96],
    byteOffset: 240,
    size: 1
  },
  aftertouchAssign: {
    name: "A.T. Assign",
    address: [3, 98],
    byteOffset: 241,
    size: 1
  },
  keyAssign: {
    name: "Key Assign",
    address: [3, 100],
    byteOffset: 242,
    size: 1
  },
  outputAssign: {
    name: "Output Assign",
    address: [3, 102],
    byteOffset: 243,
    size: 1
  }
};
var TONE_MAP_ENTRIES = 109;
var TONE_OFFSETS = {
  // === Basic Info ===
  NAME: 0,
  OUTPUT_ASSIGN: 8,
  SOURCE_TONE: 9,
  ORIG_SUB_TONE: 10,
  SAMPLING_FREQ: 11,
  ORIG_KEY_NUMBER: 12,
  WAVE_BANK: 13,
  WAVE_SEGMENT_TOP: 14,
  WAVE_SEGMENT_LENGTH: 15,
  // === Wave Points (24-bit addresses) ===
  START_POINT: 16,
  END_POINT: 19,
  LOOP_POINT: 22,
  LOOP_MODE: 25,
  // === LFO Parameters ===
  TVA_LFO_DEPTH: 26,
  LFO_RATE: 28,
  LFO_SYNC: 29,
  LFO_DELAY: 30,
  LFO_MODE: 32,
  TVA_LFO_DEPTH_2: 33,
  LFO_POLARITY: 34,
  LFO_OFFSET: 35,
  // === Pitch Parameters ===
  TRANSPOSE: 36,
  FINE_TUNE: 37,
  // === TVF Parameters ===
  TVF_CUTOFF: 38,
  TVF_RESONANCE: 39,
  TVF_KEY_FOLLOW: 40,
  TVF_LFO_DEPTH: 42,
  TVF_EG_DEPTH: 43,
  TVF_EG_POLARITY: 44,
  TVF_LEVEL_CURVE: 45,
  TVF_KEY_RATE_FOLLOW: 46,
  TVF_VEL_RATE_FOLLOW: 47,
  TVF_SWITCH: 49,
  // === Bender Switch ===
  BENDER_SWITCH: 50,
  // === TVA Envelope Config ===
  TVA_ENV_SUSTAIN_POINT: 51,
  TVA_ENV_END_POINT: 52,
  // === TVA Envelope Points 1-8 ===
  TVA_ENV_LEVEL_1: 53,
  TVA_ENV_RATE_1: 54,
  TVA_ENV_LEVEL_2: 55,
  TVA_ENV_RATE_2: 56,
  TVA_ENV_LEVEL_3: 57,
  TVA_ENV_RATE_3: 58,
  TVA_ENV_LEVEL_4: 59,
  TVA_ENV_RATE_4: 60,
  TVA_ENV_LEVEL_5: 61,
  TVA_ENV_RATE_5: 62,
  TVA_ENV_LEVEL_6: 63,
  TVA_ENV_RATE_6: 64,
  TVA_ENV_LEVEL_7: 65,
  TVA_ENV_RATE_7: 66,
  TVA_ENV_LEVEL_8: 67,
  TVA_ENV_RATE_8: 68,
  // === TVA Additional Parameters ===
  TVA_KEY_RATE: 70,
  TVA_LEVEL: 71,
  TVA_VEL_RATE: 72,
  REC_THRESHOLD: 73,
  REC_PRE_TRIGGER: 74,
  REC_SAMPLING_FREQ: 75,
  REC_START_POINT: 76,
  REC_END_POINT: 79,
  REC_LOOP_POINT: 82,
  ZOOM_T: 85,
  ZOOM_L: 86,
  COPY_SOURCE: 87,
  LOOP_TUNE: 88,
  TVA_LEVEL_CURVE: 89,
  // === Loop Length ===
  LOOP_LENGTH: 102,
  // === Additional Settings ===
  PITCH_FOLLOW: 105,
  ENV_ZOOM: 106,
  // === TVF Envelope Config ===
  TVF_ENV_SUSTAIN_POINT: 107,
  TVF_ENV_END_POINT: 108,
  // === TVF Envelope Points 1-8 ===
  TVF_ENV_LEVEL_1: 109,
  TVF_ENV_RATE_1: 110,
  TVF_ENV_LEVEL_2: 111,
  TVF_ENV_RATE_2: 112,
  TVF_ENV_LEVEL_3: 113,
  TVF_ENV_RATE_3: 114,
  TVF_ENV_LEVEL_4: 115,
  TVF_ENV_RATE_4: 116,
  TVF_ENV_LEVEL_5: 117,
  TVF_ENV_RATE_5: 118,
  TVF_ENV_LEVEL_6: 119,
  TVF_ENV_RATE_6: 120,
  TVF_ENV_LEVEL_7: 121,
  TVF_ENV_RATE_7: 122,
  TVF_ENV_LEVEL_8: 123,
  TVF_ENV_RATE_8: 124,
  // === Aftertouch Switch ===
  AFTERTOUCH_SWITCH: 125
};
var TONE_BLOCK_SIZE = 256;
var TONE_BLOCK_NIBBLES = 512;
function buildPatchAddress(patchNumber, offset) {
  return [0, 0, patchNumber * 4 & 127, offset & 127];
}
function buildPatchParamAddress(patchIndex, param) {
  const [high, low] = param.address;
  return [0, 0, patchIndex * 4 + high & 127, low & 127];
}
function buildToneAddress(toneNumber, offset) {
  const byte2 = toneNumber * 2;
  return [0, 3, byte2 & 127, offset & 127];
}
function buildSystemAddress(offset) {
  return [0, 0, 0, offset & 127];
}

// src/devices/roland-s-series/s-series-messages.ts
function nibblize(data) {
  const result = [];
  for (const byte of data) {
    result.push(byte >> 4 & 15);
    result.push(byte & 15);
  }
  return result;
}
function denibblize(nibbles) {
  const result = [];
  for (let i = 0; i < nibbles.length - 1; i += 2) {
    const msn = nibbles[i] & 15;
    const lsn = nibbles[i + 1] & 15;
    result.push(msn << 4 | lsn);
  }
  return result;
}
function calculateChecksum(address, data) {
  const sum = address.reduce((a, b) => a + b, 0) + data.reduce((a, b) => a + b, 0);
  const checksum = 128 - (sum & 127);
  return checksum === 128 ? 0 : checksum;
}
function encodeSize(size) {
  return [
    size >> 21 & 127,
    size >> 14 & 127,
    size >> 7 & 127,
    size & 127
  ];
}
function buildRQDMessage(deviceId, address, sizeNibbles) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  if ((address[3] & 1) !== 0) {
    throw new Error(`Address LSB must be EVEN, got 0x${address[3].toString(16)}`);
  }
  if ((sizeNibbles & 1) !== 0) {
    throw new Error(`Size LSB must be EVEN, got ${sizeNibbles}`);
  }
  const size = encodeSize(sizeNibbles);
  const checksum = calculateChecksum(address, size);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.RQD,
    ...address,
    ...size,
    checksum,
    247
  ];
}
function buildWSDMessage(deviceId, address, sizeBytes) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const size = encodeSize(sizeBytes);
  const checksum = calculateChecksum(address, size);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.WSD,
    ...address,
    ...size,
    checksum,
    247
  ];
}
function buildDATMessage(deviceId, address, data) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const checksum = calculateChecksum(address, data);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.DAT,
    ...address,
    ...data,
    checksum,
    247
  ];
}
function buildDT1Message(deviceId, address, data) {
  if (address.length !== 4) {
    throw new Error(`Address must be 4 bytes, got ${address.length}`);
  }
  const checksum = calculateChecksum(address, data);
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.DT1,
    ...address,
    ...data,
    checksum,
    247
  ];
}
function buildACKMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.ACK,
    247
  ];
}
function buildEODMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.EOD,
    247
  ];
}
function buildRJCMessage(deviceId) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.RJC,
    247
  ];
}
function buildERRMessage(deviceId, errorCode) {
  return [
    240,
    ROLAND_ID,
    deviceId,
    S_SERIES_MODEL_ID,
    S_SERIES_COMMANDS.ERR,
    errorCode & 127,
    247
  ];
}

// src/devices/roland-s-series/s-series-params.ts
function parseKeyMode(value) {
  switch (value) {
    case 0:
      return "normal";
    case 1:
      return "v-sw";
    case 2:
      return "x-fade";
    case 3:
      return "v-mix";
    case 4:
      return "unison";
    default:
      return "normal";
  }
}
function encodeKeyMode(mode) {
  switch (mode) {
    case "normal":
      return 0;
    case "v-sw":
      return 1;
    case "x-fade":
      return 2;
    case "v-mix":
      return 3;
    case "unison":
      return 4;
  }
}
function parseAftertouchAssign(value) {
  switch (value) {
    case 0:
      return "modulation";
    case 1:
      return "volume";
    case 2:
      return "bend+";
    case 3:
      return "bend-";
    case 4:
      return "filter";
    default:
      return "modulation";
  }
}
function encodeAftertouchAssign(assign) {
  switch (assign) {
    case "modulation":
      return 0;
    case "volume":
      return 1;
    case "bend+":
      return 2;
    case "bend-":
      return 3;
    case "filter":
      return 4;
  }
}
function parseKeyAssign(value) {
  return value === 1 ? "fix" : "rotary";
}
function encodeKeyAssign(assign) {
  return assign === "fix" ? 1 : 0;
}
function parseLoopMode(value) {
  switch (value) {
    case 0:
      return "forward";
    case 1:
      return "alternating";
    case 2:
      return "one-shot";
    case 3:
      return "reverse";
    default:
      return "forward";
  }
}
function encodeLoopMode(mode) {
  switch (mode) {
    case "forward":
      return 0;
    case "alternating":
      return 1;
    case "one-shot":
      return 2;
    case "reverse":
      return 3;
  }
}
function parseEgPolarity(value) {
  return value === 1 ? "reverse" : "normal";
}
function encodeEgPolarity(polarity) {
  return polarity === "reverse" ? 1 : 0;
}
function parseLfoMode(value) {
  return value === 1 ? "one-shot" : "normal";
}
function encodeLfoMode(mode) {
  return mode === "one-shot" ? 1 : 0;
}
function parseLevelCurve(value) {
  const clamped = Math.max(0, Math.min(5, value));
  return clamped;
}
function parseSampleRate(value) {
  return value === 0 ? "30kHz" : "15kHz";
}
function encodeSampleRate(rate) {
  return rate === "30kHz" ? 0 : 1;
}
function parseName(data, offset, length = 8) {
  let name = "";
  for (let i = 0; i < length; i++) {
    const char = data[offset + i] & 127;
    if (char >= 32 && char <= 126) {
      name += String.fromCharCode(char);
    } else {
      name += " ";
    }
  }
  return name.trimEnd();
}
function encodeName(name, length = 8) {
  const result = [];
  const padded = name.padEnd(length, " ").substring(0, length);
  for (let i = 0; i < length; i++) {
    result.push(padded.charCodeAt(i) & 127);
  }
  return result;
}
function parse21BitAddress(data, offset) {
  return (data[offset] & 127) << 14 | (data[offset + 1] & 127) << 7 | data[offset + 2] & 127;
}
function encode21BitAddress(value) {
  return [
    value >> 14 & 127,
    value >> 7 & 127,
    value & 127
  ];
}
function parse24BitAddress(data, offset) {
  var _a, _b, _c;
  const b0 = (_a = data[offset]) != null ? _a : 0;
  const b1 = (_b = data[offset + 1]) != null ? _b : 0;
  const b2 = (_c = data[offset + 2]) != null ? _c : 0;
  return b0 << 16 | b1 << 8 | b2;
}
function encode24BitAddress(value) {
  return [
    value >> 16 & 255,
    value >> 8 & 255,
    value & 255
  ];
}
function parseSignedValue(value, center = 64) {
  return value - center;
}
function encodeSignedValue(value, center = 64) {
  return Math.max(0, Math.min(127, value + center));
}
function parseEnvelope(data, sustainOffset, endOffset, levelsStart) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const levels = [
    (_a = data[levelsStart]) != null ? _a : 0,
    (_b = data[levelsStart + 2]) != null ? _b : 0,
    (_c = data[levelsStart + 4]) != null ? _c : 0,
    (_d = data[levelsStart + 6]) != null ? _d : 0,
    (_e = data[levelsStart + 8]) != null ? _e : 0,
    (_f = data[levelsStart + 10]) != null ? _f : 0,
    (_g = data[levelsStart + 12]) != null ? _g : 0,
    (_h = data[levelsStart + 14]) != null ? _h : 0
  ];
  const rates = [
    (_i = data[levelsStart + 1]) != null ? _i : 1,
    (_j = data[levelsStart + 3]) != null ? _j : 1,
    (_k = data[levelsStart + 5]) != null ? _k : 1,
    (_l = data[levelsStart + 7]) != null ? _l : 1,
    (_m = data[levelsStart + 9]) != null ? _m : 1,
    (_n = data[levelsStart + 11]) != null ? _n : 1,
    (_o = data[levelsStart + 13]) != null ? _o : 1,
    (_p = data[levelsStart + 15]) != null ? _p : 1
  ];
  const rawEndPoint = (_q = data[endOffset]) != null ? _q : 8;
  const endPoint = Math.max(1, Math.min(8, rawEndPoint));
  return {
    levels,
    rates,
    sustainPoint: (_r = data[sustainOffset]) != null ? _r : 0,
    endPoint
  };
}
function encodeEnvelope(envelope, sustainOffset, endOffset, levelsStart, output) {
  output[sustainOffset] = envelope.sustainPoint & 127;
  output[endOffset] = envelope.endPoint & 127;
  for (let i = 0; i < 8; i++) {
    output[levelsStart + i * 2] = envelope.levels[i] & 127;
    output[levelsStart + i * 2 + 1] = Math.max(1, envelope.rates[i]) & 127;
  }
}
function isValidDeviceId(id) {
  return id >= 0 && id <= 31;
}
function isValidMidiChannel(channel) {
  return channel >= 0 && channel <= 15;
}
function isValid7BitValue(value) {
  return value >= 0 && value <= 127;
}
function clamp7Bit(value) {
  return Math.max(0, Math.min(127, Math.round(value)));
}
function parseSeriesSystemParams(_data) {
  return {
    masterTune: 64,
    masterLevel: 127,
    midiChannel: 0,
    deviceId: 0,
    exclusiveEnabled: true,
    progChangeEnabled: true,
    ctrlChangeEnabled: true,
    benderEnabled: true,
    modWheelEnabled: true,
    aftertouchEnabled: true,
    holdPedalEnabled: true
  };
}
function encodeSeriesSystemParams(_params) {
  return [];
}
function parseSeriesPatchCommon(data, params) {
  const name = parseName(data, params.name.byteOffset, params.name.size);
  const toneLayer1 = [];
  for (let i = 0; i < params.toneLayer1.size; i++) {
    const value = data[params.toneLayer1.byteOffset + i];
    toneLayer1.push(value === 255 ? -1 : value);
  }
  const toneLayer2 = [];
  for (let i = 0; i < params.toneLayer2.size; i++) {
    toneLayer2.push(data[params.toneLayer2.byteOffset + i]);
  }
  const octaveShiftRaw = data[params.octaveShift.byteOffset];
  const octaveShift = octaveShiftRaw > 4 ? 0 : parseSignedValue(octaveShiftRaw, 2);
  const level = name.trim() ? data[params.level.byteOffset] : 127;
  return {
    name,
    benderRange: data[params.benderRange.byteOffset],
    aftertouchSens: data[params.aftertouchSens.byteOffset],
    keyMode: parseKeyMode(data[params.keyMode.byteOffset]),
    velocityThreshold: data[params.velocityThreshold.byteOffset],
    toneLayer1,
    toneLayer2,
    copySource: data[params.copySource.byteOffset],
    octaveShift,
    level,
    detune: parseSignedValue(data[params.detune.byteOffset]),
    velocityMixRatio: data[params.velocityMixRatio.byteOffset],
    aftertouchAssign: parseAftertouchAssign(data[params.aftertouchAssign.byteOffset]),
    keyAssign: parseKeyAssign(data[params.keyAssign.byteOffset]),
    outputAssign: data[params.outputAssign.byteOffset]
  };
}
function encodeSeriesPatchCommon(patchCommon, params) {
  const result = new Array(512).fill(0);
  const nameBytes = encodeName(patchCommon.name, params.name.size);
  for (let i = 0; i < params.name.size; i++) {
    result[params.name.byteOffset + i] = nameBytes[i];
  }
  result[params.benderRange.byteOffset] = patchCommon.benderRange;
  result[params.aftertouchSens.byteOffset] = patchCommon.aftertouchSens;
  result[params.keyMode.byteOffset] = encodeKeyMode(patchCommon.keyMode);
  result[params.velocityThreshold.byteOffset] = patchCommon.velocityThreshold;
  for (let i = 0; i < params.toneLayer1.size; i++) {
    const value = patchCommon.toneLayer1[i];
    result[params.toneLayer1.byteOffset + i] = value === -1 ? 255 : value;
  }
  for (let i = 0; i < params.toneLayer2.size; i++) {
    result[params.toneLayer2.byteOffset + i] = patchCommon.toneLayer2[i];
  }
  result[params.copySource.byteOffset] = patchCommon.copySource;
  result[params.octaveShift.byteOffset] = encodeSignedValue(patchCommon.octaveShift, 2);
  result[params.level.byteOffset] = patchCommon.level;
  result[params.detune.byteOffset] = encodeSignedValue(patchCommon.detune);
  result[params.velocityMixRatio.byteOffset] = patchCommon.velocityMixRatio;
  result[params.aftertouchAssign.byteOffset] = encodeAftertouchAssign(patchCommon.aftertouchAssign);
  result[params.keyAssign.byteOffset] = encodeKeyAssign(patchCommon.keyAssign);
  result[params.outputAssign.byteOffset] = patchCommon.outputAssign;
  return result;
}
function createEmptySeriesPatchCommon() {
  return {
    name: "",
    keyMode: "normal",
    benderRange: 2,
    aftertouchSens: 0,
    velocityThreshold: 64,
    velocityMixRatio: 64,
    level: 127,
    detune: 0,
    octaveShift: 0,
    aftertouchAssign: "modulation",
    keyAssign: "rotary",
    outputAssign: 0,
    toneLayer1: new Array(109).fill(-1),
    toneLayer2: new Array(109).fill(0),
    copySource: 0
  };
}
function parseSeriesTone(data, offsets) {
  const getByte = (offset, defaultVal = 0) => {
    var _a;
    return (_a = data[offset]) != null ? _a : defaultVal;
  };
  const wave = {
    bank: getByte(offsets.WAVE_BANK),
    segmentTop: getByte(offsets.WAVE_SEGMENT_TOP),
    segmentLength: getByte(offsets.WAVE_SEGMENT_LENGTH),
    startPoint: parse24BitAddress(data, offsets.START_POINT),
    endPoint: parse24BitAddress(data, offsets.END_POINT),
    loopPoint: parse24BitAddress(data, offsets.LOOP_POINT),
    loopLength: parse24BitAddress(data, offsets.LOOP_LENGTH)
  };
  const lfo = {
    rate: getByte(offsets.LFO_RATE),
    sync: getByte(offsets.LFO_SYNC) === 1,
    delay: getByte(offsets.LFO_DELAY),
    mode: parseLfoMode(getByte(offsets.LFO_MODE)),
    polarity: getByte(offsets.LFO_POLARITY) === 1,
    offset: getByte(offsets.LFO_OFFSET)
  };
  const tvaEnvelope = parseEnvelope(
    data,
    offsets.TVA_ENV_SUSTAIN_POINT,
    offsets.TVA_ENV_END_POINT,
    offsets.TVA_ENV_LEVEL_1
  );
  const tva = {
    lfoDepth: getByte(offsets.TVA_LFO_DEPTH),
    keyRate: getByte(offsets.TVA_KEY_RATE),
    level: getByte(offsets.TVA_LEVEL, 127),
    velRate: getByte(offsets.TVA_VEL_RATE),
    levelCurve: parseLevelCurve(getByte(offsets.TVA_LEVEL_CURVE)),
    envelope: tvaEnvelope
  };
  const tvfEnvelope = parseEnvelope(
    data,
    offsets.TVF_ENV_SUSTAIN_POINT,
    offsets.TVF_ENV_END_POINT,
    offsets.TVF_ENV_LEVEL_1
  );
  const tvf = {
    cutoff: getByte(offsets.TVF_CUTOFF, 127),
    resonance: getByte(offsets.TVF_RESONANCE),
    keyFollow: getByte(offsets.TVF_KEY_FOLLOW),
    lfoDepth: getByte(offsets.TVF_LFO_DEPTH),
    egDepth: getByte(offsets.TVF_EG_DEPTH),
    egPolarity: parseEgPolarity(getByte(offsets.TVF_EG_POLARITY)),
    levelCurve: parseLevelCurve(getByte(offsets.TVF_LEVEL_CURVE)),
    keyRateFollow: getByte(offsets.TVF_KEY_RATE_FOLLOW),
    velRateFollow: getByte(offsets.TVF_VEL_RATE_FOLLOW),
    enabled: getByte(offsets.TVF_SWITCH) === 1,
    envelope: tvfEnvelope
  };
  return {
    name: parseName(data, offsets.NAME, 8),
    outputAssign: getByte(offsets.OUTPUT_ASSIGN),
    sourceTone: getByte(offsets.SOURCE_TONE),
    origSubTone: getByte(offsets.ORIG_SUB_TONE),
    sampleRate: parseSampleRate(getByte(offsets.SAMPLING_FREQ)),
    originalKey: getByte(offsets.ORIG_KEY_NUMBER, 60),
    wave,
    loopMode: parseLoopMode(getByte(offsets.LOOP_MODE)),
    lfo,
    transpose: (() => {
      const raw = getByte(offsets.TRANSPOSE, 0);
      return raw > 127 ? raw - 256 : raw;
    })(),
    fineTune: getByte(offsets.FINE_TUNE, 0),
    tvf,
    tva,
    benderEnabled: getByte(offsets.BENDER_SWITCH) === 1,
    aftertouchEnabled: getByte(offsets.AFTERTOUCH_SWITCH) === 1,
    pitchFollow: getByte(offsets.PITCH_FOLLOW) === 1,
    recThreshold: getByte(offsets.REC_THRESHOLD),
    recPreTrigger: getByte(offsets.REC_PRE_TRIGGER),
    loopTune: (() => {
      const raw = getByte(offsets.LOOP_TUNE, 0);
      return raw > 127 ? raw - 256 : raw;
    })(),
    envZoom: getByte(offsets.ENV_ZOOM),
    copySource: getByte(offsets.COPY_SOURCE)
  };
}
function encodeSeriesTone(tone, offsets, toneBlockSize, limits) {
  const data = new Array(toneBlockSize).fill(0);
  const nameBytes = encodeName(tone.name, 8);
  for (let i = 0; i < 8; i++) {
    data[offsets.NAME + i] = nameBytes[i];
  }
  data[offsets.OUTPUT_ASSIGN] = tone.outputAssign & 127;
  data[offsets.SOURCE_TONE] = tone.sourceTone & limits.sourcetoneMask;
  data[offsets.ORIG_SUB_TONE] = tone.origSubTone & 1;
  data[offsets.SAMPLING_FREQ] = encodeSampleRate(tone.sampleRate);
  data[offsets.ORIG_KEY_NUMBER] = tone.originalKey & 127;
  data[offsets.WAVE_BANK] = tone.wave.bank & limits.waveBankMask;
  data[offsets.WAVE_SEGMENT_TOP] = tone.wave.segmentTop & 127;
  data[offsets.WAVE_SEGMENT_LENGTH] = tone.wave.segmentLength & 127;
  const startAddr = encode24BitAddress(tone.wave.startPoint);
  const endAddr = encode24BitAddress(tone.wave.endPoint);
  const loopAddr = encode24BitAddress(tone.wave.loopPoint);
  const loopLen = encode24BitAddress(tone.wave.loopLength);
  for (let i = 0; i < 3; i++) {
    data[offsets.START_POINT + i] = startAddr[i];
    data[offsets.END_POINT + i] = endAddr[i];
    data[offsets.LOOP_POINT + i] = loopAddr[i];
    data[offsets.LOOP_LENGTH + i] = loopLen[i];
  }
  data[offsets.LOOP_MODE] = encodeLoopMode(tone.loopMode);
  data[offsets.TVA_LFO_DEPTH] = tone.tva.lfoDepth & 127;
  data[offsets.LFO_RATE] = tone.lfo.rate & 127;
  data[offsets.LFO_SYNC] = tone.lfo.sync ? 1 : 0;
  data[offsets.LFO_DELAY] = tone.lfo.delay & 127;
  data[offsets.LFO_MODE] = encodeLfoMode(tone.lfo.mode);
  data[offsets.LFO_POLARITY] = tone.lfo.polarity ? 1 : 0;
  data[offsets.LFO_OFFSET] = tone.lfo.offset & 127;
  data[offsets.TRANSPOSE] = tone.transpose < 0 ? tone.transpose + 256 : tone.transpose;
  data[offsets.FINE_TUNE] = tone.fineTune & 127;
  data[offsets.TVF_CUTOFF] = tone.tvf.cutoff & 127;
  data[offsets.TVF_RESONANCE] = tone.tvf.resonance & 127;
  data[offsets.TVF_KEY_FOLLOW] = tone.tvf.keyFollow & 127;
  data[offsets.TVF_LFO_DEPTH] = tone.tvf.lfoDepth & 127;
  data[offsets.TVF_EG_DEPTH] = tone.tvf.egDepth & 127;
  data[offsets.TVF_EG_POLARITY] = encodeEgPolarity(tone.tvf.egPolarity);
  data[offsets.TVF_LEVEL_CURVE] = tone.tvf.levelCurve & 7;
  data[offsets.TVF_KEY_RATE_FOLLOW] = tone.tvf.keyRateFollow & 127;
  data[offsets.TVF_VEL_RATE_FOLLOW] = tone.tvf.velRateFollow & 127;
  data[offsets.TVF_SWITCH] = tone.tvf.enabled ? 1 : 0;
  data[offsets.BENDER_SWITCH] = tone.benderEnabled ? 1 : 0;
  encodeEnvelope(
    tone.tva.envelope,
    offsets.TVA_ENV_SUSTAIN_POINT,
    offsets.TVA_ENV_END_POINT,
    offsets.TVA_ENV_LEVEL_1,
    data
  );
  data[offsets.TVA_KEY_RATE] = tone.tva.keyRate & 127;
  data[offsets.TVA_LEVEL] = tone.tva.level & 127;
  data[offsets.TVA_VEL_RATE] = tone.tva.velRate & 127;
  data[offsets.TVA_LEVEL_CURVE] = tone.tva.levelCurve & 7;
  data[offsets.REC_THRESHOLD] = tone.recThreshold & 127;
  data[offsets.REC_PRE_TRIGGER] = tone.recPreTrigger & 3;
  data[offsets.COPY_SOURCE] = tone.copySource & limits.copySourceMask;
  data[offsets.LOOP_TUNE] = tone.loopTune < 0 ? tone.loopTune + 256 : tone.loopTune;
  data[offsets.PITCH_FOLLOW] = tone.pitchFollow ? 1 : 0;
  data[offsets.ENV_ZOOM] = tone.envZoom & 7;
  encodeEnvelope(
    tone.tvf.envelope,
    offsets.TVF_ENV_SUSTAIN_POINT,
    offsets.TVF_ENV_END_POINT,
    offsets.TVF_ENV_LEVEL_1,
    data
  );
  data[offsets.AFTERTOUCH_SWITCH] = tone.aftertouchEnabled ? 1 : 0;
  return data;
}

// src/devices/roland-s-series/s-series-wave-format.ts
function parseWav(buffer) {
  const view = new DataView(buffer);
  const riff = String.fromCharCode(view.getUint8(0), view.getUint8(1), view.getUint8(2), view.getUint8(3));
  if (riff !== "RIFF") {
    throw new Error("Invalid WAV file: missing RIFF header");
  }
  const wave = String.fromCharCode(view.getUint8(8), view.getUint8(9), view.getUint8(10), view.getUint8(11));
  if (wave !== "WAVE") {
    throw new Error("Invalid WAV file: missing WAVE format");
  }
  let offset = 12;
  let fmtChunk = null;
  let dataStart = 0;
  let dataSize = 0;
  while (offset < buffer.byteLength - 8) {
    const chunkId = String.fromCharCode(
      view.getUint8(offset),
      view.getUint8(offset + 1),
      view.getUint8(offset + 2),
      view.getUint8(offset + 3)
    );
    const chunkSize = view.getUint32(offset + 4, true);
    if (chunkId === "fmt ") {
      const audioFormat2 = view.getUint16(offset + 8, true);
      if (audioFormat2 !== 1 && audioFormat2 !== 3) {
        throw new Error(`Unsupported WAV format: ${audioFormat2} (only PCM and float supported)`);
      }
      fmtChunk = {
        audioFormat: audioFormat2,
        channels: view.getUint16(offset + 10, true),
        sampleRate: view.getUint32(offset + 12, true),
        bitsPerSample: view.getUint16(offset + 22, true)
      };
    } else if (chunkId === "data") {
      dataStart = offset + 8;
      dataSize = chunkSize;
    }
    offset += 8 + chunkSize;
    if (chunkSize % 2 !== 0) offset++;
  }
  if (!fmtChunk) {
    throw new Error("Invalid WAV file: missing fmt chunk");
  }
  if (dataStart === 0) {
    throw new Error("Invalid WAV file: missing data chunk");
  }
  const { audioFormat, channels, sampleRate, bitsPerSample } = fmtChunk;
  const bytesPerSample = bitsPerSample / 8;
  const frameCount = Math.floor(dataSize / (bytesPerSample * channels));
  const samples = new Int16Array(frameCount);
  for (let i = 0; i < frameCount; i++) {
    let sum = 0;
    for (let ch = 0; ch < channels; ch++) {
      const sampleOffset = dataStart + (i * channels + ch) * bytesPerSample;
      let sample;
      if (audioFormat === 3) {
        const floatSample = view.getFloat32(sampleOffset, true);
        sample = Math.round(Math.max(-1, Math.min(1, floatSample)) * 32767);
      } else {
        switch (bitsPerSample) {
          case 8:
            sample = (view.getUint8(sampleOffset) - 128) * 256;
            break;
          case 16:
            sample = view.getInt16(sampleOffset, true);
            break;
          case 24:
            sample = view.getUint8(sampleOffset) | view.getUint8(sampleOffset + 1) << 8 | view.getInt8(sampleOffset + 2) << 16;
            sample = sample >> 8;
            break;
          case 32:
            sample = view.getInt32(sampleOffset, true) >> 16;
            break;
          default:
            throw new Error(`Unsupported bit depth: ${bitsPerSample}`);
        }
      }
      sum += sample;
    }
    samples[i] = Math.round(sum / channels);
  }
  return { sampleRate, channels, bitsPerSample, samples };
}
function createWav(samples, sampleRate) {
  const numChannels = 1;
  const bitsPerSample = 16;
  const bytesPerSample = bitsPerSample / 8;
  const blockAlign = numChannels * bytesPerSample;
  const byteRate = sampleRate * blockAlign;
  const dataSize = samples.length * bytesPerSample;
  const headerSize = 44;
  const fileSize = headerSize + dataSize;
  const buffer = new ArrayBuffer(fileSize);
  const view = new DataView(buffer);
  view.setUint8(0, "R".charCodeAt(0));
  view.setUint8(1, "I".charCodeAt(0));
  view.setUint8(2, "F".charCodeAt(0));
  view.setUint8(3, "F".charCodeAt(0));
  view.setUint32(4, fileSize - 8, true);
  view.setUint8(8, "W".charCodeAt(0));
  view.setUint8(9, "A".charCodeAt(0));
  view.setUint8(10, "V".charCodeAt(0));
  view.setUint8(11, "E".charCodeAt(0));
  view.setUint8(12, "f".charCodeAt(0));
  view.setUint8(13, "m".charCodeAt(0));
  view.setUint8(14, "t".charCodeAt(0));
  view.setUint8(15, " ".charCodeAt(0));
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numChannels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, byteRate, true);
  view.setUint16(32, blockAlign, true);
  view.setUint16(34, bitsPerSample, true);
  view.setUint8(36, "d".charCodeAt(0));
  view.setUint8(37, "a".charCodeAt(0));
  view.setUint8(38, "t".charCodeAt(0));
  view.setUint8(39, "a".charCodeAt(0));
  view.setUint32(40, dataSize, true);
  for (let i = 0; i < samples.length; i++) {
    view.setInt16(44 + i * 2, samples[i], true);
  }
  return buffer;
}
function resample(samples, fromRate, toRate) {
  if (fromRate === toRate) {
    return samples;
  }
  const ratio = fromRate / toRate;
  const newLength = Math.floor(samples.length / ratio);
  const result = new Int16Array(newLength);
  for (let i = 0; i < newLength; i++) {
    const srcIndex = i * ratio;
    const srcIndexFloor = Math.floor(srcIndex);
    const srcIndexCeil = Math.min(srcIndexFloor + 1, samples.length - 1);
    const fraction = srcIndex - srcIndexFloor;
    result[i] = Math.round(
      samples[srcIndexFloor] * (1 - fraction) + samples[srcIndexCeil] * fraction
    );
  }
  return result;
}
function wavToSeries(wav, targetSampleRate) {
  const resampled = resample(wav.samples, wav.sampleRate, targetSampleRate);
  const sampleCount = resampled.length;
  const data = new Uint8Array(sampleCount * 2);
  for (let i = 0; i < sampleCount; i++) {
    const sample16 = resampled[i];
    let sample12 = sample16 >> 4;
    sample12 = Math.max(-2048, Math.min(2047, sample12));
    const unsigned12 = sample12 < 0 ? sample12 + 4096 : sample12;
    data[i * 2] = unsigned12 >> 5 & 127;
    data[i * 2 + 1] = unsigned12 << 2 & 124;
  }
  return { data, sampleRate: targetSampleRate, sampleCount };
}
function seriesToWav(seriesData, _sampleRate) {
  const sampleCount = Math.floor(seriesData.length / 2);
  const samples = new Int16Array(sampleCount);
  for (let i = 0; i < sampleCount; i++) {
    const byte0 = seriesData[i * 2];
    const byte1 = seriesData[i * 2 + 1];
    const sample12bit = byte0 << 5 | byte1 >> 2;
    let signedSample;
    if (sample12bit & 2048) {
      signedSample = sample12bit - 4096;
    } else {
      signedSample = sample12bit;
    }
    samples[i] = signedSample << 4;
  }
  return samples;
}
function calculateSegmentsNeeded(sampleCount) {
  const SAMPLES_PER_SEGMENT = 12e3;
  return Math.ceil(sampleCount / SAMPLES_PER_SEGMENT);
}
function validateWaveDataFits(sampleCount, segmentLength) {
  const SAMPLES_PER_SEGMENT = 12e3;
  const availableSamples = segmentLength * SAMPLES_PER_SEGMENT;
  const neededSegments = calculateSegmentsNeeded(sampleCount);
  return {
    fits: sampleCount <= availableSamples,
    neededSegments,
    availableSamples
  };
}
function prepareWavForSSeries(wavBytes, targetSampleRate, options) {
  const wavData = parseWav(wavBytes);
  const source = {
    sampleRate: wavData.sampleRate,
    bitsPerSample: wavData.bitsPerSample,
    channels: wavData.channels,
    sampleCount: wavData.samples.length,
    duration: wavData.samples.length / wavData.sampleRate
  };
  const seriesData = wavToSeries(wavData, targetSampleRate);
  const segmentLength = calculateSegmentsNeeded(seriesData.sampleCount);
  if (options == null ? void 0 : options.enableDiagnostics) {
    const expectedOutputSamples = Math.floor(wavData.samples.length * (targetSampleRate / wavData.sampleRate));
    const actualRatio = wavData.samples.length / seriesData.sampleCount;
    const expectedRatio = wavData.sampleRate / targetSampleRate;
    console.log(`[prepareWavForSSeries] ========================================`);
    console.log(`[prepareWavForSSeries] SOURCE WAV:`);
    console.log(`[prepareWavForSSeries]   Sample rate: ${wavData.sampleRate} Hz`);
    console.log(`[prepareWavForSSeries]   Bit depth: ${wavData.bitsPerSample}-bit`);
    console.log(`[prepareWavForSSeries]   Channels: ${wavData.channels}`);
    console.log(`[prepareWavForSSeries]   Sample count: ${wavData.samples.length}`);
    console.log(`[prepareWavForSSeries]   Duration: ${source.duration.toFixed(3)}s`);
    console.log(`[prepareWavForSSeries] TARGET:`);
    console.log(`[prepareWavForSSeries]   Sample rate: ${targetSampleRate} Hz`);
    console.log(`[prepareWavForSSeries]   Expected samples: ${expectedOutputSamples}`);
    console.log(`[prepareWavForSSeries] RESULT:`);
    console.log(`[prepareWavForSSeries]   Output samples: ${seriesData.sampleCount}`);
    console.log(`[prepareWavForSSeries]   Output bytes: ${seriesData.data.length}`);
    console.log(`[prepareWavForSSeries]   Segments: ${segmentLength}`);
    console.log(`[prepareWavForSSeries]   Output duration: ${(seriesData.sampleCount / targetSampleRate).toFixed(3)}s`);
    if (Math.abs(actualRatio - expectedRatio) > 0.01) {
      console.error(`[prepareWavForSSeries] WARNING: RESAMPLING MISMATCH!`);
      console.error(`[prepareWavForSSeries]   Actual ratio: ${actualRatio.toFixed(4)}`);
      console.error(`[prepareWavForSSeries]   Expected ratio: ${expectedRatio.toFixed(4)}`);
    } else {
      console.log(`[prepareWavForSSeries] Resampling verified: ${actualRatio.toFixed(4)}x`);
    }
  }
  return {
    data: seriesData.data,
    sampleCount: seriesData.sampleCount,
    segmentLength,
    sampleRate: targetSampleRate,
    source
  };
}
function clampWaveParams(wave, sampleCount) {
  const maxEndPoint = Math.max(0, sampleCount - 1);
  const endPoint = wave.endPoint > 0 ? Math.min(wave.endPoint, maxEndPoint) : maxEndPoint;
  const startPoint = Math.min(Math.max(0, wave.startPoint), endPoint);
  const loopPoint = Math.min(Math.max(0, wave.loopPoint), endPoint);
  const loopLength = Math.max(0, endPoint - loopPoint);
  return __spreadProps(__spreadValues({}, wave), {
    startPoint,
    endPoint,
    loopPoint,
    loopLength
  });
}

// src/devices/roland-s-series/s-series-client.ts
import { withRetry } from "@audiocontrol/midi-core";

// src/devices/roland-s-series/s-series-tone-factory.ts
function normalizeSampleRate(rate) {
  if (typeof rate === "number") {
    return rate === 3e4 ? "30kHz" : "15kHz";
  }
  return rate;
}
function buildDefaultToneBody(name, outputAssign, sampleRate, originalKey, transpose, effectivePitchFollow, velocitySensitivity) {
  return {
    name: name.slice(0, 8).toUpperCase().padEnd(8, " "),
    outputAssign,
    sampleRate,
    originalKey,
    lfo: {
      rate: 50,
      sync: false,
      delay: 0,
      mode: "normal",
      polarity: false,
      offset: 64
    },
    transpose,
    fineTune: 0,
    tvf: {
      cutoff: 127,
      resonance: 0,
      keyFollow: 0,
      lfoDepth: 0,
      egDepth: 0,
      egPolarity: "normal",
      levelCurve: 0,
      keyRateFollow: 0,
      velRateFollow: 0,
      enabled: false,
      envelope: {
        levels: [127, 127, 127, 127, 127, 127, 127, 127],
        rates: [127, 127, 127, 127, 127, 127, 127, 127],
        sustainPoint: 7,
        endPoint: 8
      }
    },
    tva: {
      lfoDepth: 0,
      keyRate: 0,
      level: 127,
      velRate: 0,
      levelCurve: Math.max(0, Math.min(5, velocitySensitivity)),
      envelope: {
        levels: [127, 127, 127, 127, 127, 127, 127, 0],
        rates: [127, 127, 127, 127, 127, 127, 127, 30],
        sustainPoint: 6,
        endPoint: 8
      }
    },
    benderEnabled: effectivePitchFollow,
    aftertouchEnabled: false,
    pitchFollow: effectivePitchFollow,
    recThreshold: 64,
    recPreTrigger: 0,
    loopTune: 0,
    envZoom: 0,
    copySource: 0
  };
}
function createSeriesTone(config) {
  const {
    name,
    sampleRate,
    waveBank,
    segmentTop,
    segmentLength,
    sampleCount,
    loopMode = "one-shot",
    loopPoint = 0,
    originalKey = 60,
    transpose = 0,
    pitchFollow,
    outputAssign = 0,
    velocitySensitivity = 0
  } = config;
  const effectivePitchFollow = pitchFollow != null ? pitchFollow : loopMode !== "one-shot";
  return __spreadProps(__spreadValues({}, buildDefaultToneBody(
    name,
    outputAssign,
    normalizeSampleRate(sampleRate),
    originalKey,
    transpose,
    effectivePitchFollow,
    velocitySensitivity
  )), {
    sourceTone: 0,
    origSubTone: 0,
    wave: {
      bank: waveBank,
      segmentTop,
      segmentLength,
      startPoint: 0,
      endPoint: Math.max(0, sampleCount - 1),
      loopPoint,
      loopLength: Math.max(0, sampleCount - 1 - loopPoint)
    },
    loopMode
  });
}
function createSeriesSubTone(config, limits) {
  const {
    name,
    sourceToneIndex,
    sampleRate,
    startPoint,
    endPoint,
    loopMode = "one-shot",
    loopPoint = startPoint,
    originalKey = 60,
    transpose = 0,
    pitchFollow,
    outputAssign = 0,
    velocitySensitivity = 0
  } = config;
  const effectivePitchFollow = pitchFollow != null ? pitchFollow : loopMode !== "one-shot";
  return __spreadProps(__spreadValues({}, buildDefaultToneBody(
    name,
    outputAssign,
    normalizeSampleRate(sampleRate),
    originalKey,
    transpose,
    effectivePitchFollow,
    velocitySensitivity
  )), {
    sourceTone: sourceToneIndex & limits.sourcetoneMask,
    origSubTone: 1,
    wave: {
      bank: 0,
      segmentTop: 0,
      segmentLength: 0,
      startPoint,
      endPoint,
      loopPoint,
      loopLength: Math.max(0, endPoint - loopPoint)
    },
    loopMode
  });
}
function createSeriesMonolithicPrimaryTone(config, startPoint, endPoint) {
  const tone = createSeriesTone(config);
  tone.wave.startPoint = startPoint;
  tone.wave.endPoint = endPoint;
  tone.wave.loopPoint = startPoint;
  tone.wave.loopLength = endPoint - startPoint;
  tone.sourceTone = 0;
  tone.origSubTone = 0;
  return tone;
}

// src/devices/s330/s330-addresses.ts
var ROLAND_ID2 = ROLAND_ID;
var S330_MODEL_ID = S_SERIES_MODEL_ID;
var DEFAULT_DEVICE_ID2 = DEFAULT_DEVICE_ID;
var S330_COMMANDS = S_SERIES_COMMANDS;
var ERROR_CODES2 = ERROR_CODES;
var TIMING2 = TIMING;
var BULK_DUMP_TYPES2 = BULK_DUMP_TYPES;
var calculateChecksum2 = calculateChecksum;
var PATCH_PARAMS2 = PATCH_PARAMS;
var PATCH_COMMON_OFFSETS2 = PATCH_COMMON_OFFSETS;
var TONE_OFFSETS2 = TONE_OFFSETS;
var PATCH_TOTAL_SIZE2 = PATCH_TOTAL_SIZE;
var TONE_BLOCK_SIZE2 = TONE_BLOCK_SIZE;
var TONE_BLOCK_NIBBLES2 = TONE_BLOCK_NIBBLES;
var TONE_MAP_ENTRIES2 = TONE_MAP_ENTRIES;
var buildPatchAddress2 = buildPatchAddress;
var buildPatchParamAddress2 = buildPatchParamAddress;
var buildToneAddress2 = buildToneAddress;
var buildSystemAddress2 = buildSystemAddress;
var ADDR_SYSTEM = [0, 0, 0, 0];
var ADDR_PATCH_BASE = [0, 0, 0, 0];
var ADDR_TONE_BASE = [0, 3, 0, 0];
var TONE_STRIDE = 2;
var ADDR_WAVE_DATA = [1, 0, 0, 0];
var SYSTEM_OFFSETS = {
  MASTER_TUNE: 0,
  MASTER_LEVEL: 1,
  MIDI_CHANNEL: 2,
  DEVICE_ID: 3,
  EXCLUSIVE_ENABLE: 4,
  PROG_CHANGE_ENABLE: 5,
  CTRL_CHANGE_ENABLE: 6,
  BENDER_ENABLE: 7,
  MOD_WHEEL_ENABLE: 8,
  AFTERTOUCH_ENABLE: 9,
  HOLD_PEDAL_ENABLE: 10
};
var SYSTEM_BLOCK_SIZE = 11;
var MAX_PATCHES = 64;
var MAX_TONES = 32;
var VALUE_RANGES2 = __spreadProps(__spreadValues({}, VALUE_RANGES), {
  /** Tone number range (S-330: 0-31) */
  TONE_NUMBER: { min: 0, max: 31 },
  /** Patch number range (S-330: 0-63) */
  PATCH_NUMBER: { min: 0, max: 63 },
  /** Partial count range */
  PARTIAL_COUNT: { min: 0, max: 31 }
});
var S330_SEGMENT_ADDR_STRIDE = 24576;
var S330_BANK_B_OFFSET = 32 << 14;
function buildWaveDataAddress(waveBank, segmentIndex) {
  if (waveBank < 0 || waveBank > 1) {
    throw new Error(`S-330 wave bank ${waveBank} out of range (0-1)`);
  }
  if (segmentIndex < 0 || segmentIndex > 17) {
    throw new Error(`Segment index ${segmentIndex} out of range (0-17)`);
  }
  const bankBaseAddr = waveBank === 0 ? 0 : S330_BANK_B_OFFSET;
  const addrOffset = bankBaseAddr + segmentIndex * S330_SEGMENT_ADDR_STRIDE;
  return [
    ADDR_WAVE_DATA[0],
    addrOffset >> 14 & 127,
    addrOffset >> 7 & 127,
    addrOffset & 126
    // LSB must be even per Roland spec
  ];
}

// src/devices/s330/s330-params.ts
var parseSystemParams = (data) => parseSeriesSystemParams(data);
var encodeSystemParams = (params) => encodeSeriesSystemParams(params);
var parsePatchCommon = (data) => parseSeriesPatchCommon(data, PATCH_PARAMS2);
var encodePatchCommon = (params) => encodeSeriesPatchCommon(params, PATCH_PARAMS2);
var createEmptyPatchCommon = (_index) => createEmptySeriesPatchCommon();
var parseTone = (data) => parseSeriesTone(data, TONE_OFFSETS2);
var encodeTone = (tone) => encodeSeriesTone(tone, TONE_OFFSETS2, TONE_BLOCK_SIZE2, S330_DEVICE_LIMITS);
var isValidPatchNumber = (num) => num >= 0 && num <= S330_DEVICE_LIMITS.maxPatchNumber;
var isValidToneNumber = (num) => num >= 0 && num <= S330_DEVICE_LIMITS.maxToneNumber;

// src/devices/s330/s330-messages.ts
function buildPatchAddressRQD(patchNumber) {
  if (patchNumber < 0 || patchNumber >= 64) {
    throw new Error(`Patch number must be 0-63, got ${patchNumber}`);
  }
  return [0, 0, patchNumber * 4 & 127, 0];
}

// src/devices/s330/s330-tone-factory.ts
function createTone(config) {
  return createSeriesTone(config);
}
function createSubTone(config) {
  return createSeriesSubTone(config, S330_DEVICE_LIMITS);
}
function createMonolithicPrimaryTone(config, startPoint, endPoint) {
  return createSeriesMonolithicPrimaryTone(config, startPoint, endPoint);
}

// src/devices/s330/s330-client.ts
import { withRetry as withRetry2 } from "@audiocontrol/midi-core";
var S330_DATA_TYPES = {
  ALL_DATA: 0,
  PATCH_1_32: 1,
  PATCH_33_64: 2,
  TONE_1_32: 3,
  TONE_33_64: 4,
  FUNCTION: 5
};
var S330_FUNCTION_ADDRESSES = {
  // MULTI MIDI RX-CH (MIDI channel assignments 0-15 = Ch 1-16)
  MULTI_CHANNEL_A: 34,
  MULTI_CHANNEL_B: 35,
  MULTI_CHANNEL_C: 36,
  MULTI_CHANNEL_D: 37,
  MULTI_CHANNEL_E: 38,
  MULTI_CHANNEL_F: 39,
  MULTI_CHANNEL_G: 40,
  MULTI_CHANNEL_H: 41,
  // MULTI PATCH NUMBER (patch index 0-63)
  MULTI_PATCH_A: 50,
  MULTI_PATCH_B: 51,
  MULTI_PATCH_C: 52,
  MULTI_PATCH_D: 53,
  MULTI_PATCH_E: 54,
  MULTI_PATCH_F: 55,
  MULTI_PATCH_G: 56,
  MULTI_PATCH_H: 57,
  // MULTI OUTPUT ASSIGN (output 1-8, 0=mix)
  MULTI_OUTPUT_A: 66,
  MULTI_OUTPUT_B: 67,
  MULTI_OUTPUT_C: 68,
  MULTI_OUTPUT_D: 69,
  MULTI_OUTPUT_E: 70,
  MULTI_OUTPUT_F: 71,
  MULTI_OUTPUT_G: 72,
  MULTI_OUTPUT_H: 73,
  // MULTI LEVEL (level 0-127)
  MULTI_LEVEL_A: 86,
  MULTI_LEVEL_B: 87,
  MULTI_LEVEL_C: 88,
  MULTI_LEVEL_D: 89,
  MULTI_LEVEL_E: 90,
  MULTI_LEVEL_F: 91,
  MULTI_LEVEL_G: 92,
  MULTI_LEVEL_H: 93
};
function deNibblize(nibbles) {
  const bytes = [];
  for (let i = 0; i < nibbles.length - 1; i += 2) {
    const high = (nibbles[i] & 15) << 4;
    const low = nibbles[i + 1] & 15;
    bytes.push(high | low);
  }
  return bytes;
}
function nibblize2(bytes) {
  const nibbles = [];
  for (const byte of bytes) {
    nibbles.push(byte >> 4 & 15);
    nibbles.push(byte & 15);
  }
  return nibbles;
}
function createS330Client(midiAdapter, options = {}) {
  var _a, _b, _c, _d;
  const deviceId = (_a = options.deviceId) != null ? _a : DEFAULT_DEVICE_ID2;
  const timeoutMs = (_b = options.timeoutMs) != null ? _b : TIMING2.ACK_TIMEOUT_MS;
  const writeFlushDelayMs = (_c = options.writeFlushDelayMs) != null ? _c : 150;
  const buildWaveAddress = (_d = options.buildWaveAddress) != null ? _d : buildWaveDataAddress;
  let connected = false;
  let patchCache = new Array(MAX_PATCHES).fill(void 0);
  let toneCache = new Array(MAX_TONES).fill(void 0);
  let requestQueue = Promise.resolve();
  function serialize(fn) {
    const result = requestQueue.then(fn, fn);
    requestQueue = result.catch(() => {
    });
    return result;
  }
  const writeBuffer = /* @__PURE__ */ new Map();
  let flushTimer = null;
  let flushPromise = null;
  function addressKey(address) {
    return address.join(",");
  }
  function flushWriteBuffer() {
    return __async(this, null, function* () {
      if (writeBuffer.size === 0) return;
      const pending = Array.from(writeBuffer.values());
      writeBuffer.clear();
      flushTimer = null;
      for (const { address, data } of pending) {
        yield serialize(() => __async(null, null, function* () {
          yield sendData(address, data);
        }));
      }
    });
  }
  function bufferWrite(address, data) {
    if (writeFlushDelayMs === 0) {
      return serialize(() => __async(null, null, function* () {
        yield sendData(address, data);
      }));
    }
    const key = addressKey(address);
    writeBuffer.set(key, { address, data });
    if (!flushTimer) {
      flushPromise = new Promise((resolve, reject) => {
        flushTimer = setTimeout(() => {
          flushWriteBuffer().then(resolve).catch(reject);
        }, writeFlushDelayMs);
      });
    }
    return flushPromise;
  }
  function sendAndReceive(message) {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        midiAdapter.removeSysExListener(listener);
        reject(new Error("S-330 response timeout"));
      }, timeoutMs);
      function listener(response) {
        if (response.length >= 5 && response[1] === ROLAND_ID2 && response[2] === deviceId && response[3] === S330_MODEL_ID) {
          clearTimeout(timeout);
          midiAdapter.removeSysExListener(listener);
          resolve(response);
        }
      }
      midiAdapter.onSysEx(listener);
      midiAdapter.send(message);
    });
  }
  function requestDataWithAddress(address, sizeInBytes) {
    return __async(this, null, function* () {
      if (address.length !== 4) {
        throw new Error("Address must be 4 bytes");
      }
      if (address[3] & 1) {
        throw new Error(
          `Address LSB must be even (got 0x${address[3].toString(16)})`
        );
      }
      const sizeInNibbles = sizeInBytes * 2;
      const size = [
        sizeInNibbles >> 21 & 127,
        sizeInNibbles >> 14 & 127,
        sizeInNibbles >> 7 & 127,
        sizeInNibbles & 127
      ];
      const cs = calculateChecksum2(address, size);
      const message = [
        240,
        ROLAND_ID2,
        deviceId,
        S330_MODEL_ID,
        S330_COMMANDS.RQD,
        ...address,
        ...size,
        cs,
        247
      ];
      return new Promise((resolve, reject) => {
        const allNibbles = [];
        let timeoutId;
        function resetTimeout() {
          if (timeoutId) clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            midiAdapter.removeSysExListener(listener);
            if (allNibbles.length > 0) {
              resolve(deNibblize(allNibbles));
            } else {
              reject(new Error("RQD response timeout - no data received"));
            }
          }, timeoutMs * 2);
        }
        function sendAck() {
          const ackMsg = [
            240,
            ROLAND_ID2,
            deviceId,
            S330_MODEL_ID,
            S330_COMMANDS.ACK,
            247
          ];
          midiAdapter.send(ackMsg);
        }
        function listener(response) {
          console.log("[S330Client] Received:", response.slice(0, 10).map((b) => b.toString(16).padStart(2, "0")).join(" "), response.length > 10 ? `... (${response.length} bytes)` : "");
          if (response.length < 5) return;
          if (response[1] !== ROLAND_ID2) return;
          if (response[3] !== S330_MODEL_ID) return;
          const respDeviceId = response[2];
          const command = response[4];
          if (respDeviceId !== deviceId) {
            if (command === S330_COMMANDS.RJC || command === S330_COMMANDS.ERR) {
              clearTimeout(timeoutId);
              midiAdapter.removeSysExListener(listener);
              reject(
                new Error(
                  `S-330 device ID mismatch (device: ${respDeviceId}, expected: ${deviceId})`
                )
              );
            }
            return;
          }
          resetTimeout();
          if (command === S330_COMMANDS.RJC) {
            console.warn("[S330Client] Ignoring stale RJC during RQD");
            return;
          }
          if (command === S330_COMMANDS.DAT) {
            const respAddr = response.slice(5, 9);
            if (allNibbles.length === 0) {
              const addrMatch = respAddr[0] === address[0] && respAddr[1] === address[1] && respAddr[2] === address[2] && respAddr[3] === address[3];
              if (!addrMatch) {
                console.warn(`[S330Client] Ignoring stale DAT packet for address ${respAddr.map((b) => b.toString(16).padStart(2, "0")).join(" ")} (expected ${address.map((b) => b.toString(16).padStart(2, "0")).join(" ")})`);
                sendAck();
                return;
              }
            }
            const dataStart = 9;
            const dataEnd = response.length - 2;
            const nibbles = response.slice(dataStart, dataEnd);
            allNibbles.push(...nibbles);
            sendAck();
          } else if (command === S330_COMMANDS.EOD || command === 69) {
            clearTimeout(timeoutId);
            midiAdapter.removeSysExListener(listener);
            sendAck();
            resolve(deNibblize(allNibbles));
          } else if (command === S330_COMMANDS.ERR) {
            clearTimeout(timeoutId);
            midiAdapter.removeSysExListener(listener);
            reject(new Error("S-330 communication error"));
          }
        }
        resetTimeout();
        midiAdapter.onSysEx(listener);
        console.log("[S330Client] Sending RQD:", message.map((b) => b.toString(16).padStart(2, "0")).join(" "));
        midiAdapter.send(message);
      });
    });
  }
  function sendDataAttempt(address, data) {
    return new Promise((resolve, reject) => {
      let phase = "WSD";
      let phaseStartTime = Date.now();
      const timeoutId = setTimeout(() => {
        const elapsed = Date.now() - phaseStartTime;
        console.log(`[S330Client] sendData TIMEOUT in phase ${phase} after ${elapsed}ms`);
        midiAdapter.removeSysExListener(listener);
        reject(new Error(`WSD write timeout in phase ${phase}`));
      }, timeoutMs);
      function listener(response) {
        if (response.length < 5) return;
        if (response[1] !== ROLAND_ID2) return;
        if (response[2] !== deviceId) return;
        if (response[3] !== S330_MODEL_ID) return;
        const command = response[4];
        if (command === S330_COMMANDS.RJC) {
          console.warn(`[S330Client] Ignoring stale RJC during ${phase} phase`);
          return;
        }
        if (command === S330_COMMANDS.ERR) {
          clearTimeout(timeoutId);
          midiAdapter.removeSysExListener(listener);
          reject(new Error(`WSD communication error in phase ${phase}`));
          return;
        }
        if (command === S330_COMMANDS.ACK) {
          const elapsed = Date.now() - phaseStartTime;
          console.log(`[S330Client] sendData ACK received in phase ${phase} after ${elapsed}ms`);
          if (phase === "WSD") {
            phase = "DAT";
            phaseStartTime = Date.now();
            const nibblized = nibblize2(data);
            const datChecksum = calculateChecksum2(address, nibblized);
            const datMessage = [
              240,
              ROLAND_ID2,
              deviceId,
              S330_MODEL_ID,
              S330_COMMANDS.DAT,
              ...address,
              ...nibblized,
              datChecksum,
              247
            ];
            console.log(`[S330Client] sendData sending DAT (${nibblized.length} nibbles): ${datMessage.slice(5, 49).map((b) => b.toString(16).padStart(2, "0")).join(" ")}...`);
            midiAdapter.send(datMessage);
          } else if (phase === "DAT") {
            phase = "EOD";
            phaseStartTime = Date.now();
            clearTimeout(timeoutId);
            const eodMessage = [
              240,
              ROLAND_ID2,
              deviceId,
              S330_MODEL_ID,
              S330_COMMANDS.EOD,
              247
            ];
            console.log(`[S330Client] sendData sending EOD`);
            midiAdapter.send(eodMessage);
            setTimeout(() => {
              if (phase === "EOD") {
                console.log(`[S330Client] sendData EOD not ACKed, assuming success`);
                phase = "DONE";
                midiAdapter.removeSysExListener(listener);
                resolve();
              }
            }, 300);
          } else if (phase === "EOD") {
            console.log(`[S330Client] sendData complete`);
            phase = "DONE";
            clearTimeout(timeoutId);
            midiAdapter.removeSysExListener(listener);
            resolve();
          }
        }
      }
      midiAdapter.onSysEx(listener);
      const sizeInNibbles = data.length * 2;
      const size = [
        sizeInNibbles >> 21 & 127,
        sizeInNibbles >> 14 & 127,
        sizeInNibbles >> 7 & 127,
        sizeInNibbles & 127
      ];
      const wsdChecksum = calculateChecksum2(address, size);
      const wsdMessage = [
        240,
        ROLAND_ID2,
        deviceId,
        S330_MODEL_ID,
        S330_COMMANDS.WSD,
        ...address,
        ...size,
        wsdChecksum,
        247
      ];
      console.log(`[S330Client] sendData sending WSD: ${wsdMessage.map((b) => b.toString(16).padStart(2, "0")).join(" ")}`);
      phaseStartTime = Date.now();
      midiAdapter.send(wsdMessage);
    });
  }
  const wsdRetryOptions = {
    maxRetries: TIMING2.MAX_RETRIES,
    initialDelayMs: TIMING2.RETRY_DELAY_MS,
    maxDelayMs: 2e3,
    multiplier: 2,
    jitter: 0.3,
    isRetryable: (error) => {
      if (error instanceof Error) {
        return error.message.includes("timeout") || error.message.includes("rejected");
      }
      return false;
    },
    onRetry: (attempt, error, delayMs) => {
      console.log(`[S330Client] WSD retry ${attempt} after ${delayMs}ms: ${error}`);
    }
  };
  function sendData(address, data) {
    return __async(this, null, function* () {
      if (address.length !== 4) {
        throw new Error("Address must be 4 bytes");
      }
      const addrStr = address.map((b) => b.toString(16).padStart(2, "0")).join(" ");
      console.log(`[S330Client] sendData: address=${addrStr}, dataLen=${data.length}`);
      return withRetry2(() => sendDataAttempt(address, data), wsdRetryOptions);
    });
  }
  function sendWaveDataInternal(input, onProgress) {
    return __async(this, null, function* () {
      const { data, waveBank, segmentTop } = input;
      const waveAddress = buildWaveAddress(waveBank, segmentTop);
      console.log(`[S330Client] Sending wave data: ${data.length} bytes to bank=${waveBank}, segment=${segmentTop}`);
      console.log(`[S330Client] Wave address: ${waveAddress.map((b) => b.toString(16).padStart(2, "0")).join(" ")}`);
      yield sendWaveDataChunked(waveAddress, data, onProgress);
    });
  }
  function sendWaveDataChunked(address, data, onProgress) {
    return __async(this, null, function* () {
      if (address.length !== 4) {
        throw new Error("Address must be 4 bytes");
      }
      if (address[3] & 1) {
        throw new Error(`Address LSB must be even (got 0x${address[3].toString(16)})`);
      }
      const totalBytes = data.length;
      const MAX_CHUNK_BYTES = 128;
      return new Promise((resolve, reject) => {
        let bytesSent = 0;
        let currentByteOffset = 0;
        let phase = "WSD";
        let timeoutId;
        function resetTimeout() {
          if (timeoutId) clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            midiAdapter.removeSysExListener(listener);
            reject(new Error(`Wave data send timeout in phase ${phase} (sent ${bytesSent}/${totalBytes})`));
          }, timeoutMs * 4);
        }
        function sendNextChunk() {
          if (currentByteOffset >= totalBytes) {
            phase = "EOD";
            const eodMessage = [
              240,
              ROLAND_ID2,
              deviceId,
              S330_MODEL_ID,
              S330_COMMANDS.EOD,
              247
            ];
            midiAdapter.send(eodMessage);
            setTimeout(() => {
              if (phase === "EOD") {
                phase = "DONE";
                clearTimeout(timeoutId);
                midiAdapter.removeSysExListener(listener);
                resolve();
              }
            }, 500);
            return;
          }
          phase = "DAT";
          const chunkEndByte = Math.min(currentByteOffset + MAX_CHUNK_BYTES, totalBytes);
          const chunkBytes = Array.from(data.slice(currentByteOffset, chunkEndByte));
          const baseOffset = address[1] << 14 | address[2] << 7 | address[3];
          const chunkAddr = baseOffset + currentByteOffset;
          const chunkAddress = [
            address[0],
            chunkAddr >> 14 & 127,
            chunkAddr >> 7 & 127,
            chunkAddr & 127
          ];
          const datChecksum = calculateChecksum2(chunkAddress, chunkBytes);
          const datMessage = [
            240,
            ROLAND_ID2,
            deviceId,
            S330_MODEL_ID,
            S330_COMMANDS.DAT,
            ...chunkAddress,
            ...chunkBytes,
            datChecksum,
            247
          ];
          midiAdapter.send(datMessage);
          bytesSent = chunkEndByte;
          currentByteOffset = chunkEndByte;
          onProgress == null ? void 0 : onProgress(bytesSent, totalBytes);
        }
        function listener(response) {
          if (response.length < 5) return;
          if (response[1] !== ROLAND_ID2) return;
          if (response[2] !== deviceId) return;
          if (response[3] !== S330_MODEL_ID) return;
          const command = response[4];
          resetTimeout();
          if (command === S330_COMMANDS.RJC) {
            console.warn(`[S330Client] Ignoring stale RJC during wave ${phase} phase`);
            return;
          }
          if (command === S330_COMMANDS.ERR) {
            clearTimeout(timeoutId);
            midiAdapter.removeSysExListener(listener);
            reject(new Error(`Wave data communication error in phase ${phase}`));
            return;
          }
          if (command === S330_COMMANDS.ACK) {
            if (phase === "WSD") {
              setTimeout(() => sendNextChunk(), 10);
            } else if (phase === "DAT") {
              setTimeout(() => sendNextChunk(), 5);
            } else if (phase === "EOD") {
              phase = "DONE";
              clearTimeout(timeoutId);
              midiAdapter.removeSysExListener(listener);
              resolve();
            }
          }
        }
        midiAdapter.onSysEx(listener);
        resetTimeout();
        const size = [
          totalBytes >> 21 & 127,
          totalBytes >> 14 & 127,
          totalBytes >> 7 & 127,
          totalBytes & 127
        ];
        const wsdChecksum = calculateChecksum2(address, size);
        const wsdMessage = [
          240,
          ROLAND_ID2,
          deviceId,
          S330_MODEL_ID,
          S330_COMMANDS.WSD,
          ...address,
          ...size,
          wsdChecksum,
          247
        ];
        console.log("[S330Client] Sending WSD:", wsdMessage.map((b) => b.toString(16).padStart(2, "0")).join(" "));
        midiAdapter.send(wsdMessage);
      });
    });
  }
  return {
    connect() {
      return __async(this, null, function* () {
        connected = true;
        return true;
      });
    },
    disconnect() {
      connected = false;
    },
    isConnected() {
      return connected;
    },
    getDeviceId() {
      return deviceId;
    },
    /**
     * Send MIDI panic: All Sound Off (CC#120) and All Notes Off (CC#123) on all channels.
     * This immediately silences all notes without waiting for the message queue.
     * Use when notes get stuck during heavy SysEx traffic.
     */
    panic() {
      for (let channel = 0; channel < 16; channel++) {
        const status = 176 + channel;
        midiAdapter.send([status, 120, 0]);
        midiAdapter.send([status, 123, 0]);
      }
      console.log("[S330Client] Panic: sent All Sound Off and All Notes Off on all channels");
    },
    /**
     * Request full patch data for a specific patch
     * Serialized to prevent concurrent request interference
     */
    requestPatchData(patchIndex) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          try {
            const address = [0, 0, patchIndex * 4, 0];
            const data = yield requestDataWithAddress(address, PATCH_TOTAL_SIZE2);
            const common = parsePatchCommon(data);
            return { common };
          } catch (err) {
            console.error(`[S330Client] Error loading patch ${patchIndex}:`, err);
            return null;
          }
        }));
      });
    },
    /**
     * Load a range of patches with progress callbacks and caching.
     * Only fetches patches that aren't already cached (unless forceReload).
     */
    loadPatchRange(startIndex, count, onProgress, onPatchLoaded, forceReload) {
      return __async(this, null, function* () {
        const endIndex = Math.min(startIndex + count, MAX_PATCHES);
        const actualCount = endIndex - startIndex;
        if (forceReload) {
          for (let i = startIndex; i < endIndex; i++) {
            patchCache[i] = void 0;
          }
        }
        return serialize(() => __async(null, null, function* () {
          console.log(`[S330Client] Loading patches ${startIndex}-${endIndex - 1}${forceReload ? " (forced)" : ""}...`);
          const result = [];
          let loaded = 0;
          for (let i = startIndex; i < endIndex; i++) {
            if (patchCache[i] !== void 0) {
              const patch2 = patchCache[i];
              result.push(patch2);
              loaded++;
              onProgress == null ? void 0 : onProgress(loaded, actualCount);
              onPatchLoaded == null ? void 0 : onPatchLoaded(i, patch2);
              continue;
            }
            let patch;
            try {
              const address = [0, 0, i * 4, 0];
              const data = yield requestDataWithAddress(address, PATCH_TOTAL_SIZE2);
              const common = parsePatchCommon(data);
              patch = { common };
            } catch (err) {
              console.error(`[S330Client] Error parsing patch ${i}:`, err);
              const placeholder = {
                name: "!ERROR!",
                keyMode: "normal",
                benderRange: 0,
                aftertouchSens: 0,
                aftertouchAssign: "modulation",
                keyAssign: "rotary",
                outputAssign: 0,
                level: 0,
                detune: 0,
                velocityThreshold: 0,
                velocityMixRatio: 0,
                octaveShift: 0,
                toneLayer1: [],
                toneLayer2: [],
                copySource: 0
              };
              patch = { common: placeholder };
            }
            patchCache[i] = patch;
            result.push(patch);
            loaded++;
            onProgress == null ? void 0 : onProgress(loaded, actualCount);
            onPatchLoaded == null ? void 0 : onPatchLoaded(i, patch);
          }
          console.log(`[S330Client] Loaded ${result.length} patches (${startIndex}-${endIndex - 1})`);
          return result;
        }));
      });
    },
    /**
     * Get currently loaded patches (sparse array, undefined = not loaded)
     */
    getLoadedPatches() {
      return [...patchCache];
    },
    /**
     * Invalidate the patch cache, forcing a reload on next access.
     */
    invalidatePatchCache() {
      console.log("[S330Client] Invalidating patch cache");
      patchCache = new Array(MAX_PATCHES).fill(void 0);
    },
    /**
     * Request full tone data for a specific tone
     * Serialized to prevent concurrent request interference
     *
     * Tone data is 256 bytes (512 nibbles) and includes:
     * - Basic info (name, output, sample rate, original key)
     * - Wave parameters (start/end/loop points)
     * - LFO parameters
     * - 8-point TVA envelope with sustain/end points
     * - 8-point TVF envelope with sustain/end points
     * - Various switches and recording parameters
     */
    requestToneData(toneIndex) {
      return __async(this, null, function* () {
        if (toneIndex < 0 || toneIndex >= MAX_TONES) {
          throw new Error(`Invalid tone index: ${toneIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          try {
            const byte2 = toneIndex * 2;
            const address = [0, 3, byte2, 0];
            const data = yield withRetry2(
              () => requestDataWithAddress(address, TONE_BLOCK_SIZE2),
              wsdRetryOptions
            );
            return parseTone(data);
          } catch (err) {
            console.error(`[S330Client] requestToneData(${toneIndex}) failed after retries:`, err);
            return null;
          }
        }));
      });
    },
    /**
     * Load a range of tones with progress callbacks and caching.
     * Only fetches tones that aren't already cached (unless forceReload).
     */
    loadToneRange(startIndex, count, onProgress, onToneLoaded, forceReload) {
      return __async(this, null, function* () {
        const endIndex = Math.min(startIndex + count, MAX_TONES);
        const actualCount = endIndex - startIndex;
        if (forceReload) {
          for (let i = startIndex; i < endIndex; i++) {
            toneCache[i] = void 0;
          }
        }
        return serialize(() => __async(null, null, function* () {
          console.log(`[S330Client] Loading tones ${startIndex}-${endIndex - 1}${forceReload ? " (forced)" : ""}...`);
          const result = [];
          let loaded = 0;
          for (let i = startIndex; i < endIndex; i++) {
            if (toneCache[i] !== void 0) {
              const tone2 = toneCache[i];
              result.push(tone2);
              loaded++;
              onProgress == null ? void 0 : onProgress(loaded, actualCount);
              onToneLoaded == null ? void 0 : onToneLoaded(i, tone2);
              continue;
            }
            let tone;
            try {
              const byte2 = i * 2;
              const address = [0, 3, byte2, 0];
              const data = yield requestDataWithAddress(address, TONE_BLOCK_SIZE2);
              tone = parseTone(data);
            } catch (err) {
              console.error(`[S330Client] Error loading tone ${i}:`, err);
              tone = null;
            }
            if (tone) {
              toneCache[i] = tone;
              result.push(tone);
              loaded++;
              onProgress == null ? void 0 : onProgress(loaded, actualCount);
              onToneLoaded == null ? void 0 : onToneLoaded(i, tone);
            } else {
              loaded++;
              onProgress == null ? void 0 : onProgress(loaded, actualCount);
            }
          }
          console.log(`[S330Client] Loaded ${result.length} tones (${startIndex}-${endIndex - 1})`);
          return result;
        }));
      });
    },
    /**
     * Get currently loaded tones (sparse array, undefined = not loaded)
     */
    getLoadedTones() {
      return [...toneCache];
    },
    /**
     * Invalidate the tone cache, forcing a reload on next access.
     */
    invalidateToneCache() {
      console.log("[S330Client] Invalidating tone cache");
      toneCache = new Array(MAX_TONES).fill(void 0);
    },
    /**
     * Send tone data to S-330
     * Uses WSD/DAT/EOD protocol to write complete tone block.
     * Writes are buffered and rate-limited to prevent flooding the device.
     *
     * @param toneIndex - Tone number (0-31)
     * @param tone - Complete tone data structure
     * @returns Promise that resolves when tone is written
     */
    sendToneData(toneIndex, tone) {
      return __async(this, null, function* () {
        if (toneIndex < 0 || toneIndex >= MAX_TONES) {
          throw new Error(`Invalid tone index: ${toneIndex}`);
        }
        const toneBytes = encodeTone(tone);
        const byte2 = toneIndex * 2;
        const address = [0, 3, byte2, 0];
        return bufferWrite(address, toneBytes);
      });
    },
    /**
     * Request wave data for a tone
     *
     * Fetches the raw sample data for a tone from the S-330's wave memory.
     * The S-330 stores samples as 12-bit linear PCM, packed as 2 samples per 3 bytes.
     *
     * @param toneIndex - Tone number (0-31)
     * @param onProgress - Optional progress callback with bytes received and total bytes
     * @returns Wave data response with raw sample bytes and metadata
     */
    requestWaveData(toneIndex, onProgress) {
      return __async(this, null, function* () {
        console.log("[S330Client] requestWaveData called with toneIndex:", toneIndex);
        if (toneIndex < 0 || toneIndex >= MAX_TONES) {
          throw new Error(`Invalid tone index: ${toneIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          const byte2 = toneIndex * 2;
          const toneAddress = [0, 3, byte2, 0];
          console.log("[S330Client] Fetching tone data from address:", toneAddress);
          const toneData = yield withRetry2(
            () => requestDataWithAddress(toneAddress, TONE_BLOCK_SIZE2),
            wsdRetryOptions
          );
          if (toneData.length < 26) {
            throw new Error("Insufficient tone data received");
          }
          const sampleRateValue = toneData[11];
          const sampleRate = sampleRateValue === 1 ? 15e3 : 3e4;
          const waveBank = toneData[13];
          const waveSegmentTop = toneData[14];
          const waveSegmentLength = toneData[15];
          const relativeStart = toneData[16] << 16 | toneData[17] << 8 | toneData[18];
          const relativeEnd = toneData[19] << 16 | toneData[20] << 8 | toneData[21];
          const relativeLoop = toneData[22] << 16 | toneData[23] << 8 | toneData[24];
          const loopModeValue = toneData[25];
          const loopMode = ["forward", "alternating", "one-shot", "reverse"][loopModeValue] || "forward";
          console.log("[S330Client] Parsed wave params for tone", toneIndex, ":", {
            sampleRate,
            waveBank,
            waveSegmentTop,
            waveSegmentLength,
            relativeStart,
            relativeEnd,
            relativeLoop,
            loopMode
          });
          const SEGMENT_SIZE_SAMPLES = 12e3;
          const waveAddress = buildWaveAddress(waveBank, waveSegmentTop);
          const sampleCount = waveSegmentLength * SEGMENT_SIZE_SAMPLES;
          const bytesToFetch = sampleCount * 2;
          if (sampleCount <= 0) {
            throw new Error(`Invalid segment allocation: segmentLength=${waveSegmentLength}`);
          }
          console.log(`[S330Client] Fetching wave data: ${sampleCount} samples (${waveSegmentLength} segments), ${bytesToFetch} bytes`);
          console.log(`[S330Client] Wave address: bank=${waveBank}, segmentTop=${waveSegmentTop}, address=${waveAddress.map((b) => b.toString(16).padStart(2, "0")).join(" ")}`);
          const waveTimeoutMs = Math.max(timeoutMs * 4, bytesToFetch / 100);
          const waveData = yield withRetry2(
            () => requestWaveDataWithProgress(
              waveAddress,
              bytesToFetch,
              waveTimeoutMs,
              onProgress
            ),
            wsdRetryOptions
          );
          return {
            data: new Uint8Array(waveData),
            sampleRate,
            startPoint: relativeStart,
            endPoint: relativeEnd,
            loopPoint: relativeLoop,
            loopMode
          };
        }));
        function requestWaveDataWithProgress(address, sizeInBytes, waveTimeoutMs, onProgress2) {
          return __async(this, null, function* () {
            if (address.length !== 4) {
              throw new Error("Address must be 4 bytes");
            }
            if (address[3] & 1) {
              throw new Error(`Address LSB must be even (got 0x${address[3].toString(16)})`);
            }
            const size = [
              sizeInBytes >> 21 & 127,
              sizeInBytes >> 14 & 127,
              sizeInBytes >> 7 & 127,
              sizeInBytes & 127
            ];
            const cs = calculateChecksum2(address, size);
            const message = [
              240,
              ROLAND_ID2,
              deviceId,
              S330_MODEL_ID,
              S330_COMMANDS.RQD,
              ...address,
              ...size,
              cs,
              247
            ];
            return new Promise((resolve, reject) => {
              const allBytes = [];
              let timeoutId;
              function resetTimeout() {
                if (timeoutId) clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                  midiAdapter.removeSysExListener(listener);
                  if (allBytes.length > 0) {
                    resolve(allBytes);
                  } else {
                    reject(new Error("Wave data request timeout - no data received"));
                  }
                }, waveTimeoutMs);
              }
              function sendAck() {
                const ackMsg = [
                  240,
                  ROLAND_ID2,
                  deviceId,
                  S330_MODEL_ID,
                  S330_COMMANDS.ACK,
                  247
                ];
                midiAdapter.send(ackMsg);
              }
              function listener(response) {
                if (response.length < 5) return;
                if (response[1] !== ROLAND_ID2) return;
                if (response[3] !== S330_MODEL_ID) return;
                const respDeviceId = response[2];
                const command = response[4];
                if (respDeviceId !== deviceId) {
                  return;
                }
                resetTimeout();
                if (command === S330_COMMANDS.RJC) {
                  console.warn("[S330Client] Ignoring stale RJC during wave RQD");
                  return;
                }
                if (command === S330_COMMANDS.DAT) {
                  const dataStart = 9;
                  const dataEnd = response.length - 2;
                  const data = response.slice(dataStart, dataEnd);
                  allBytes.push(...data);
                  onProgress2 == null ? void 0 : onProgress2(allBytes.length, sizeInBytes);
                  sendAck();
                } else if (command === S330_COMMANDS.EOD || command === 69) {
                  clearTimeout(timeoutId);
                  midiAdapter.removeSysExListener(listener);
                  sendAck();
                  resolve(allBytes);
                } else if (command === S330_COMMANDS.ERR) {
                  clearTimeout(timeoutId);
                  midiAdapter.removeSysExListener(listener);
                  reject(new Error("Wave data communication error"));
                }
              }
              resetTimeout();
              midiAdapter.onSysEx(listener);
              console.log("[S330Client] Requesting wave data:", message.map((b) => b.toString(16).padStart(2, "0")).join(" "));
              midiAdapter.send(message);
            });
          });
        }
      });
    },
    /**
     * Send wave data to the S-330.
     *
     * Uses WSD/DAT/EOD protocol to upload wave samples to wave memory.
     * The data must be pre-encoded as 7-bit MIDI bytes (2 bytes per 12-bit sample).
     *
     * @param input - Wave data and target location
     * @param onProgress - Optional progress callback
     */
    sendWaveData(input, onProgress) {
      return __async(this, null, function* () {
        const { waveBank, segmentTop, segmentLength } = input;
        if (waveBank !== 0 && waveBank !== 1) {
          throw new Error(`Invalid wave bank: ${waveBank} (must be 0 or 1)`);
        }
        if (segmentTop < 0 || segmentTop >= 18) {
          throw new Error(`Invalid segment top: ${segmentTop} (must be 0-17)`);
        }
        if (segmentLength < 1 || segmentTop + segmentLength > 18) {
          throw new Error(`Invalid segment length: ${segmentLength}`);
        }
        return serialize(() => __async(null, null, function* () {
          yield sendWaveDataInternal(input, onProgress);
        }));
      });
    },
    /**
     * Import a tone with wave data to the S-330.
     *
     * Uploads wave data to the specified segment and configures
     * the tone parameters to use it.
     *
     * @param input - Import configuration
     * @param onProgress - Optional progress callback
     */
    importTone(input, onProgress) {
      return __async(this, null, function* () {
        var _a2, _b2, _c2, _d2, _e2;
        const {
          toneIndex,
          waveData,
          waveBank,
          segmentTop,
          segmentLength
        } = input;
        if (toneIndex < 0 || toneIndex >= MAX_TONES) {
          throw new Error(`Invalid tone index: ${toneIndex} (must be 0-31)`);
        }
        if (waveBank !== 0 && waveBank !== 1) {
          throw new Error(`Invalid wave bank: ${waveBank} (must be 0 or 1)`);
        }
        if (segmentTop < 0 || segmentTop >= 18) {
          throw new Error(`Invalid segment top: ${segmentTop} (must be 0-17)`);
        }
        if (segmentLength < 1 || segmentTop + segmentLength > 18) {
          throw new Error(`Invalid segment length: ${segmentLength}`);
        }
        const sampleCount = waveData.length / 2;
        const maxSamples = segmentLength * 12e3;
        if (sampleCount > maxSamples) {
          throw new Error(`Wave data too large: ${sampleCount} samples exceeds ${maxSamples} for ${segmentLength} segments`);
        }
        console.log("[S330Client] Step 1: Configuring tone parameters...");
        let tone;
        if (input.tone) {
          const toneName = input.tone.name;
          console.log(`[S330Client] Importing existing tone ${toneIndex}: "${toneName}" to bank ${waveBank}, segment ${segmentTop}`);
          const clampedWave = clampWaveParams(
            __spreadProps(__spreadValues({}, input.tone.wave), {
              bank: waveBank,
              segmentTop,
              segmentLength
            }),
            sampleCount
          );
          tone = __spreadProps(__spreadValues({}, input.tone), {
            wave: clampedWave
          });
        } else {
          const name = (_a2 = input.name) != null ? _a2 : "UNNAMED";
          const sampleRate = (_b2 = input.sampleRate) != null ? _b2 : "30kHz";
          const loopMode = (_c2 = input.loopMode) != null ? _c2 : "one-shot";
          const loopPoint = (_d2 = input.loopPoint) != null ? _d2 : 0;
          const originalKey = (_e2 = input.originalKey) != null ? _e2 : 60;
          console.log(`[S330Client] Importing new tone ${toneIndex}: "${name}" to bank ${waveBank}, segment ${segmentTop}`);
          tone = createTone({
            name,
            sampleRate,
            waveBank,
            segmentTop,
            segmentLength,
            sampleCount,
            loopMode,
            loopPoint,
            originalKey
          });
        }
        console.log(`[S330Client] Tone wave alloc: bank=${tone.wave.bank}, segTop=${tone.wave.segmentTop}, segLen=${tone.wave.segmentLength}, start=${tone.wave.startPoint}, end=${tone.wave.endPoint}`);
        yield this.sendToneData(toneIndex, tone);
        console.log("[S330Client] Step 2: Uploading wave data...");
        yield this.sendWaveData(
          {
            data: waveData,
            waveBank,
            segmentTop,
            segmentLength
          },
          onProgress
        );
        console.log("[S330Client] Waiting for S-330 to process wave data...");
        yield new Promise((resolve) => setTimeout(resolve, 500));
        console.log(`[S330Client] Step 3: Re-sending tone parameters...`);
        console.log(`[S330Client] Step 3 wave alloc: bank=${tone.wave.bank}, segTop=${tone.wave.segmentTop}, segLen=${tone.wave.segmentLength}`);
        yield this.sendToneData(toneIndex, tone);
        console.log(`[S330Client] Tone ${toneIndex} imported successfully`);
      });
    },
    /**
     * Request all function parameters (Multi mode configuration)
     * Serialized to prevent concurrent request interference
     *
     * Address base: 00 01 00 00 (function parameters bank per MIDI Implementation)
     * Returns configuration for all 8 parts (A-H)
     */
    requestFunctionParameters() {
      return __async(this, null, function* () {
        return serialize(() => __async(null, null, function* () {
          var _a2, _b2, _c2, _d2;
          try {
            const channelData = yield requestDataWithAddress(
              [0, 1, 0, 34],
              8
            );
            const patchData = yield requestDataWithAddress(
              [0, 1, 0, 50],
              8
            );
            let outputData;
            try {
              outputData = yield requestDataWithAddress(
                [0, 1, 0, 66],
                8
              );
            } catch (err) {
              outputData = [1, 1, 1, 1, 1, 1, 1, 1];
            }
            const levelData = yield requestDataWithAddress(
              [0, 1, 0, 86],
              8
            );
            const parts = [];
            for (let i = 0; i < 8; i++) {
              parts.push({
                channel: (_a2 = channelData[i]) != null ? _a2 : 0,
                patchIndex: (_b2 = patchData[i]) != null ? _b2 : 0,
                output: (_c2 = outputData[i]) != null ? _c2 : 1,
                level: (_d2 = levelData[i]) != null ? _d2 : 127
              });
            }
            return parts;
          } catch (err) {
            return Array.from({ length: 8 }, (_, i) => ({
              channel: i,
              patchIndex: 0,
              output: 1,
              level: 127
            }));
          }
        }));
      });
    },
    /**
     * Set MIDI receive channel for a multi mode part
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters)
     */
    setMultiChannel(part, channel) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (channel < 0 || channel > 15) {
          throw new Error(`Invalid channel: ${channel} (must be 0-15)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allChannelData = yield requestDataWithAddress(
            [0, 1, 0, 34],
            8
          );
          const newChannelData = [...allChannelData];
          newChannelData[part] = channel;
          yield sendData([0, 1, 0, 34], newChannelData);
        }));
      });
    },
    /**
     * Set patch assignment for a multi mode part
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters)
     */
    setMultiPatch(part, patchIndex) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        const value = patchIndex === null ? 127 : patchIndex;
        if (patchIndex !== null && (patchIndex < 0 || patchIndex > 63)) {
          throw new Error(`Invalid patch index: ${patchIndex} (must be 0-63 or null)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allPatchData = yield requestDataWithAddress(
            [0, 1, 0, 50],
            8
          );
          const newPatchData = [...allPatchData];
          newPatchData[part] = value;
          yield sendData([0, 1, 0, 50], newPatchData);
        }));
      });
    },
    /**
     * Set output assignment for a multi mode part
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters)
     */
    setMultiOutput(part, output) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (output < 0 || output > 8) {
          throw new Error(`Invalid output: ${output} (must be 0-8)`);
        }
        return serialize(() => __async(null, null, function* () {
          let allOutputData;
          try {
            allOutputData = yield requestDataWithAddress(
              [0, 1, 0, 66],
              8
            );
          } catch (err) {
            allOutputData = [1, 1, 1, 1, 1, 1, 1, 1];
          }
          const newOutputData = [...allOutputData];
          newOutputData[part] = output;
          yield sendData([0, 1, 0, 66], newOutputData);
        }));
      });
    },
    /**
     * Set level for a multi mode part
     * Uses WSD/DAT/EOD protocol (DT1 does not work for function parameters)
     */
    setMultiLevel(part, level) {
      return __async(this, null, function* () {
        if (part < 0 || part > 7) {
          throw new Error(`Invalid part number: ${part} (must be 0-7)`);
        }
        if (level < 0 || level > 127) {
          throw new Error(`Invalid level: ${level} (must be 0-127)`);
        }
        return serialize(() => __async(null, null, function* () {
          const allLevelData = yield requestDataWithAddress(
            [0, 1, 0, 86],
            8
          );
          const newLevelData = [...allLevelData];
          newLevelData[part] = level;
          yield sendData([0, 1, 0, 86], newLevelData);
        }));
      });
    },
    /**
     * Set patch name
     * Uses 2-byte writes in 8-byte chunks at the exact name address
     * @param patchIndex - Patch number (0-63)
     * @param name - Patch name (max 12 characters, padded with spaces)
     */
    setPatchName(patchIndex, name) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.name);
          const nameBytes = Array(PATCH_PARAMS2.name.size).fill(32);
          for (let i = 0; i < Math.min(name.length, PATCH_PARAMS2.name.size); i++) {
            nameBytes[i] = name.charCodeAt(i);
          }
          yield sendData(address, nameBytes.slice(0, 8));
          const secondAddress = [...address];
          secondAddress[3] = secondAddress[3] + 16 & 127;
          yield sendData(secondAddress, nameBytes.slice(8, 12));
        }));
      });
    },
    /**
     * Set key mode for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchKeyMode(patchIndex, keyMode) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        const keyModeValue = keyMode === "normal" ? 0 : keyMode === "v-sw" ? 1 : keyMode === "x-fade" ? 2 : keyMode === "v-mix" ? 3 : 4;
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.keyMode);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = keyModeValue;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set bender range for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchBenderRange(patchIndex, range) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (range < 0 || range > 12) {
          throw new Error(`Invalid bender range: ${range} (must be 0-12)`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.benderRange);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = range;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set aftertouch sensitivity for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchAftertouchSens(patchIndex, sens) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (sens < 0 || sens > 127) {
          throw new Error(`Invalid aftertouch sensitivity: ${sens}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.aftertouchSens);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = sens;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set output assignment for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchOutput(patchIndex, output) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (output < 0 || output > 8) {
          throw new Error(`Invalid output: ${output} (must be 0-8)`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.outputAssign);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = output;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set level for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchLevel(patchIndex, level) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (level < 0 || level > 127) {
          throw new Error(`Invalid level: ${level}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.level);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = level;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set detune for a patch (unison mode)
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     * @param detune - Detune amount (-64 to +63, displayed as -64 to +63)
     */
    setPatchDetune(patchIndex, detune) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (detune < -64 || detune > 63) {
          throw new Error(`Invalid detune: ${detune} (must be -64 to +63)`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.detune);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = encodeSignedValue(detune);
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set velocity threshold for a patch (V-Sw mode)
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     * @param threshold - Velocity threshold (0-127)
     */
    setPatchVelocityThreshold(patchIndex, threshold) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (threshold < 0 || threshold > 127) {
          throw new Error(`Invalid velocity threshold: ${threshold}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.velocityThreshold);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = threshold;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set velocity mix ratio for a patch (V-Mix mode)
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     * @param ratio - Velocity mix ratio (0-127)
     */
    setPatchVelocityMixRatio(patchIndex, ratio) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (ratio < 0 || ratio > 127) {
          throw new Error(`Invalid velocity mix ratio: ${ratio}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.velocityMixRatio);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = ratio;
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set octave shift for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     * @param shift - Octave shift (-2 to +2)
     */
    setPatchOctaveShift(patchIndex, shift) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        if (shift < -2 || shift > 2) {
          throw new Error(`Invalid octave shift: ${shift} (must be -2 to +2)`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.octaveShift);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = encodeSignedValue(shift, 2);
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set aftertouch assignment for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchAftertouchAssign(patchIndex, assign) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.aftertouchAssign);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = encodeAftertouchAssign(assign);
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Set key assignment mode for a patch
     * Uses 8-byte read-modify-write (S-330 requires 8-byte minimum for WSD)
     */
    setPatchKeyAssign(patchIndex, assign) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        return serialize(() => __async(null, null, function* () {
          const address = buildPatchParamAddress2(patchIndex, PATCH_PARAMS2.keyAssign);
          const data = yield requestDataWithAddress(address, 8);
          const newData = [...data];
          newData[0] = encodeKeyAssign(assign);
          yield sendData(address, newData);
        }));
      });
    },
    /**
     * Send complete patch data to S-330
     * Uses WSD/DAT/EOD protocol to write patch common section.
     * Writes are buffered and rate-limited to prevent flooding the device.
     *
     * @param patchIndex - Patch number (0-63)
     * @param patch - Complete patch common data structure
     * @returns Promise that resolves when patch is written
     */
    sendPatchData(patchIndex, patch) {
      return __async(this, null, function* () {
        if (patchIndex < 0 || patchIndex >= MAX_PATCHES) {
          throw new Error(`Invalid patch index: ${patchIndex}`);
        }
        const patchBytes = encodePatchCommon(patch);
        const address = [0, 0, patchIndex * 4, 0];
        return bufferWrite(address, patchBytes);
      });
    }
  };
}

// src/devices/s330/s330-parameter-listener.ts
function deNibblize2(nibbles) {
  const bytes = [];
  for (let i = 0; i < nibbles.length - 1; i += 2) {
    const high = (nibbles[i] & 15) << 4;
    const low = nibbles[i + 1] & 15;
    bytes.push(high | low);
  }
  return bytes;
}
function mapAddressToType(address) {
  const [byte0, byte1, byte2, byte3] = address;
  if (byte0 !== 0) {
    return null;
  }
  switch (byte1) {
    case 0:
      return {
        type: "patch",
        index: Math.floor(byte2 / 4)
      };
    case 1:
      return {
        type: "function",
        index: -1
        // Function params don't have an index
      };
    case 3:
      return {
        type: "tone",
        index: Math.floor(byte2 / 2)
      };
    case 4:
      if (byte2 === 0 && byte3 === 0) {
        return null;
      }
      return null;
    default:
      return null;
  }
}
function parseDT1Message(message, expectedDeviceId) {
  if (message.length < 12) {
    return { valid: false, event: null, reason: "Message too short" };
  }
  if (message[0] !== 240 || message[message.length - 1] !== 247) {
    return { valid: false, event: null, reason: "Not a SysEx message" };
  }
  if (message[1] !== ROLAND_ID2) {
    return { valid: false, event: null, reason: "Not a Roland message" };
  }
  if (message[3] !== S330_MODEL_ID) {
    return { valid: false, event: null, reason: "Not an S-330 message" };
  }
  if (message[4] !== S330_COMMANDS.DT1) {
    return { valid: false, event: null, reason: "Not a DT1 command" };
  }
  const deviceId = message[2];
  if (expectedDeviceId !== void 0 && deviceId !== expectedDeviceId) {
    return { valid: false, event: null, reason: `Device ID mismatch (got ${deviceId}, expected ${expectedDeviceId})` };
  }
  const address = [message[5], message[6], message[7], message[8]];
  const mapped = mapAddressToType(address);
  if (mapped === null) {
    return { valid: false, event: null, reason: "Address is UI state or unknown" };
  }
  const dataNibbles = message.slice(9, message.length - 2);
  const data = deNibblize2(dataNibbles);
  return {
    valid: true,
    event: {
      type: mapped.type,
      index: mapped.index,
      address,
      data,
      timestamp: Date.now()
    }
  };
}
function isDT1Message(message) {
  return message.length >= 12 && message[0] === 240 && message[1] === ROLAND_ID2 && message[3] === S330_MODEL_ID && message[4] === S330_COMMANDS.DT1 && message[message.length - 1] === 247;
}
function isUIStateAddress(address) {
  return address.length >= 4 && address[0] === 0 && address[1] === 4 && address[2] === 0 && address[3] === 0;
}

// src/devices/s330/s330-front-panel.ts
var FRONT_PANEL_ADDRESS = [0, 4, 0, 0];
var ARROW_CODES_CAT01 = {
  right: [1, 0],
  left: [1, 1],
  up: [1, 2],
  down: [1, 3]
};
var ARROW_CODES_CAT09 = {
  right: { press: [9, 0], release: [9, 8] },
  left: { press: [9, 1], release: [9, 9] },
  up: { press: [9, 2], release: [9, 10] },
  down: { press: [9, 3], release: [9, 11] }
};
var VALUE_CODES = {
  inc: { press: [9, 4], release: [9, 12] },
  dec: { press: [9, 5], release: [9, 13] }
};
var NAVIGATION_DELAY_MS = 50;
var FUNCTION_CODES = {
  mode: [1, 11],
  menu: [1, 12],
  "sub-menu": [1, 13],
  com: [1, 14],
  execute: [1, 15]
};
var NAVIGATION_BUTTONS = /* @__PURE__ */ new Set(["up", "down", "left", "right", "inc", "dec"]);
var ARROW_BUTTONS = /* @__PURE__ */ new Set(["up", "down", "left", "right"]);
var VALUE_BUTTONS = /* @__PURE__ */ new Set(["inc", "dec"]);
function isNavigationButton(button) {
  return NAVIGATION_BUTTONS.has(button);
}
function isArrowButton(button) {
  return ARROW_BUTTONS.has(button);
}
function isValueButton(button) {
  return VALUE_BUTTONS.has(button);
}
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function buildFrontPanelMessage(deviceId, data) {
  const checksum = calculateChecksum2(FRONT_PANEL_ADDRESS, data);
  return [
    240,
    ROLAND_ID2,
    deviceId,
    S330_MODEL_ID,
    S330_COMMANDS.DT1,
    ...FRONT_PANEL_ADDRESS,
    ...data,
    checksum,
    247
  ];
}
function createFrontPanelController(midiAdapter, options = {}) {
  var _a;
  const deviceId = (_a = options.deviceId) != null ? _a : 0;
  return {
    pressNavigation(button, mode = "menu") {
      return __async(this, null, function* () {
        if (isArrowButton(button)) {
          if (mode === "menu") {
            const code = ARROW_CODES_CAT01[button];
            const message = buildFrontPanelMessage(deviceId, code);
            midiAdapter.send(message);
          } else {
            const codes = ARROW_CODES_CAT09[button];
            const pressMessage = buildFrontPanelMessage(deviceId, codes.press);
            const releaseMessage = buildFrontPanelMessage(deviceId, codes.release);
            midiAdapter.send(pressMessage);
            yield delay(NAVIGATION_DELAY_MS);
            midiAdapter.send(releaseMessage);
          }
        } else if (isValueButton(button)) {
          const codes = VALUE_CODES[button];
          const pressMessage = buildFrontPanelMessage(deviceId, codes.press);
          const releaseMessage = buildFrontPanelMessage(deviceId, codes.release);
          midiAdapter.send(pressMessage);
          yield delay(NAVIGATION_DELAY_MS);
          midiAdapter.send(releaseMessage);
        }
      });
    },
    pressFunction(button) {
      return __async(this, null, function* () {
        const code = FUNCTION_CODES[button];
        const message = buildFrontPanelMessage(deviceId, code);
        midiAdapter.send(message);
      });
    },
    press(button, mode = "menu") {
      return __async(this, null, function* () {
        if (isNavigationButton(button)) {
          yield this.pressNavigation(button, mode);
        } else {
          yield this.pressFunction(button);
        }
      });
    }
  };
}

// src/devices/s330/s330-wave-format.ts
function wavToS330(wav, targetSampleRate) {
  return wavToSeries(wav, targetSampleRate);
}
function s330ToWav(s330Data, sampleRate) {
  return seriesToWav(s330Data, sampleRate);
}
function prepareWavForS330(wavBytes, targetSampleRate, options) {
  return prepareWavForSSeries(wavBytes, targetSampleRate, options);
}

// src/devices/s330/s330-tone-layer.ts
var TONE_LAYER_MIN_MIDI_NOTE = 12;
var TONE_LAYER_MAX_MIDI_NOTE = 120;
var TONE_LAYER_SIZE = 109;
var TONE_LAYER_OFF = -1;
function midiNoteToLayerIndex(midiNote) {
  const index = midiNote - TONE_LAYER_MIN_MIDI_NOTE;
  if (index < 0 || index >= TONE_LAYER_SIZE) {
    return -1;
  }
  return index;
}
function layerIndexToMidiNote(index) {
  if (index < 0 || index >= TONE_LAYER_SIZE) {
    return -1;
  }
  return index + TONE_LAYER_MIN_MIDI_NOTE;
}
function createEmptyToneLayer(layer) {
  const offValue = layer === 1 ? TONE_LAYER_OFF : 0;
  return new Array(TONE_LAYER_SIZE).fill(offValue);
}
function getToneAtMidiNote(toneLayer, midiNote) {
  const index = midiNoteToLayerIndex(midiNote);
  if (index < 0) {
    return void 0;
  }
  return toneLayer[index];
}
function setToneAtMidiNote(toneLayer, midiNote, toneSlot) {
  const index = midiNoteToLayerIndex(midiNote);
  if (index < 0) {
    return false;
  }
  toneLayer[index] = toneSlot;
  return true;
}
function setToneForMidiRange(toneLayer, startMidiNote, endMidiNote, toneSlot) {
  let count = 0;
  for (let note = startMidiNote; note <= endMidiNote; note++) {
    if (setToneAtMidiNote(toneLayer, note, toneSlot)) {
      count++;
    }
  }
  return count;
}
function isValidToneLayerMidiNote(midiNote) {
  return midiNote >= TONE_LAYER_MIN_MIDI_NOTE && midiNote <= TONE_LAYER_MAX_MIDI_NOTE;
}
function toneLayerToZones(toneLayer, layer) {
  const zones = [];
  const offValue = layer === 1 ? TONE_LAYER_OFF : 0;
  let i = 0;
  while (i < TONE_LAYER_SIZE) {
    const currentTone = toneLayer[i];
    if (currentTone === offValue) {
      i++;
      continue;
    }
    const startMidiNote = layerIndexToMidiNote(i);
    while (i < TONE_LAYER_SIZE && toneLayer[i] === currentTone) {
      i++;
    }
    const endMidiNote = layerIndexToMidiNote(i - 1);
    zones.push({ startMidiNote, endMidiNote, toneSlot: currentTone });
  }
  return zones;
}
function zonesToToneLayer(zones, layer) {
  const toneLayer = createEmptyToneLayer(layer);
  for (const zone of zones) {
    setToneForMidiRange(toneLayer, zone.startMidiNote, zone.endMidiNote, zone.toneSlot);
  }
  return toneLayer;
}

// src/devices/s330/drum-kit-import-service.ts
var DEFAULT_ORIGINAL_KEY = 60;
function createDrumTone(name, sampleRate, waveBank, segmentTop, segmentLength, sampleCount, originalKey = DEFAULT_ORIGINAL_KEY, transpose = 0, velocitySensitivity = 2) {
  return createTone({
    name,
    sampleRate,
    waveBank,
    segmentTop,
    segmentLength,
    sampleCount,
    loopMode: "one-shot",
    originalKey,
    transpose,
    pitchFollow: false,
    velocitySensitivity
  });
}
function createSingleNotePatch(name, toneSlot, midiNote) {
  const toneLayer1 = createEmptyToneLayer(1);
  setToneAtMidiNote(toneLayer1, midiNote, toneSlot);
  const common = {
    name: name.slice(0, 12).toUpperCase().padEnd(12, " "),
    benderRange: 2,
    aftertouchSens: 64,
    keyMode: "normal",
    velocityThreshold: 64,
    toneLayer1,
    toneLayer2: createEmptyToneLayer(2),
    copySource: 0,
    octaveShift: 0,
    level: 127,
    detune: 0,
    velocityMixRatio: 64,
    aftertouchAssign: "modulation",
    keyAssign: "rotary",
    outputAssign: 8
  };
  return { common };
}
function createDrumKitPatch(name, mappings) {
  const toneLayer1 = createEmptyToneLayer(1);
  for (const mapping of mappings) {
    setToneAtMidiNote(toneLayer1, mapping.midiNote, mapping.toneSlot);
  }
  const common = {
    name: name.slice(0, 12).toUpperCase().padEnd(12, " "),
    benderRange: 2,
    aftertouchSens: 64,
    keyMode: "normal",
    velocityThreshold: 64,
    toneLayer1,
    toneLayer2: createEmptyToneLayer(2),
    copySource: 0,
    octaveShift: 0,
    level: 127,
    detune: 0,
    velocityMixRatio: 64,
    aftertouchAssign: "modulation",
    keyAssign: "rotary",
    outputAssign: 8
  };
  return { common };
}
function importDrumKit(client, config, onProgress) {
  return __async(this, null, function* () {
    const results = [];
    let currentSegment = config.startingSegment;
    const toneMappings = [];
    for (let i = 0; i < config.samples.length; i++) {
      const sample = config.samples[i];
      const toneSlot = config.startingToneSlot + i;
      onProgress == null ? void 0 : onProgress(i + 1, config.samples.length, `Converting ${sample.drumType}...`);
      const prepared = prepareWavForS330(sample.wavData, config.sampleRate);
      console.log(`[DrumKitImportService] Sample ${i}: ${sample.drumType}`);
      console.log(`  - WAV size: ${sample.wavData.byteLength} bytes`);
      console.log(`  - S330 data: ${prepared.data.length} bytes`);
      console.log(`  - Sample count: ${prepared.sampleCount}`);
      console.log(`  - Segments needed: ${prepared.segmentLength}`);
      console.log(`  - Target segment: ${currentSegment}`);
      console.log(`  - Tone slot: ${toneSlot}`);
      const toneName = `${sample.drumType.slice(0, 4).toUpperCase()}${sample.kitNumber}`;
      const tone = createDrumTone(
        toneName,
        config.sampleRate,
        config.waveBank,
        currentSegment,
        prepared.segmentLength,
        prepared.sampleCount,
        config.originalKey
      );
      onProgress == null ? void 0 : onProgress(i + 1, config.samples.length, `Uploading ${sample.drumType}...`);
      yield client.importTone({
        toneIndex: toneSlot,
        waveData: prepared.data,
        waveBank: config.waveBank,
        segmentTop: currentSegment,
        segmentLength: prepared.segmentLength,
        tone
      });
      toneMappings.push({ midiNote: sample.midiNote, toneSlot });
      results.push({
        toneSlot,
        patchSlot: config.singlePatch ? config.startingPatchSlot : config.startingPatchSlot + i,
        segmentTop: currentSegment,
        segmentLength: prepared.segmentLength,
        sampleCount: prepared.sampleCount,
        tone,
        patch: null
        // Will be set in Phase 2
      });
      currentSegment += prepared.segmentLength;
      yield new Promise((resolve) => setTimeout(resolve, 500));
    }
    if (config.singlePatch) {
      const patchName = config.patchName || "DRUMKIT";
      const patch = createDrumKitPatch(patchName, toneMappings);
      onProgress == null ? void 0 : onProgress(config.samples.length, config.samples.length, `Creating patch ${patchName}...`);
      yield client.sendPatchData(config.startingPatchSlot, patch.common);
      for (const result of results) {
        result.patch = patch;
      }
      console.log(`[DrumKitImportService] Created single patch "${patchName}" with ${toneMappings.length} tone mappings`);
    } else {
      for (let i = 0; i < config.samples.length; i++) {
        const sample = config.samples[i];
        const toneSlot = config.startingToneSlot + i;
        const patchSlot = config.startingPatchSlot + i;
        const patchName = `${sample.drumType.slice(0, 4).toUpperCase()}${sample.kitNumber}`;
        const patch = createSingleNotePatch(patchName, toneSlot, sample.midiNote);
        onProgress == null ? void 0 : onProgress(i + 1, config.samples.length, `Creating patch ${patchName}...`);
        yield client.sendPatchData(patchSlot, patch.common);
        results[i].patch = patch;
      }
    }
    const totalSegments = currentSegment - config.startingSegment;
    return { samples: results, totalSegments };
  });
}
function verifyDrumKitImport(client, importResult) {
  return __async(this, null, function* () {
    const errors = [];
    for (const sample of importResult.samples) {
      const tone = yield client.requestToneData(sample.toneSlot);
      if (!tone) {
        errors.push(`Tone ${sample.toneSlot} not found on device`);
        continue;
      }
      if (tone.wave.bank !== sample.tone.wave.bank) {
        errors.push(`Tone ${sample.toneSlot}: wave bank mismatch (expected ${sample.tone.wave.bank}, got ${tone.wave.bank})`);
      }
      if (tone.wave.segmentTop !== sample.tone.wave.segmentTop) {
        errors.push(`Tone ${sample.toneSlot}: segmentTop mismatch (expected ${sample.tone.wave.segmentTop}, got ${tone.wave.segmentTop})`);
      }
      if (tone.wave.segmentLength !== sample.tone.wave.segmentLength) {
        errors.push(`Tone ${sample.toneSlot}: segmentLength mismatch (expected ${sample.tone.wave.segmentLength}, got ${tone.wave.segmentLength})`);
      }
      if (tone.loopMode !== "one-shot") {
        errors.push(`Tone ${sample.toneSlot}: loopMode should be 'one-shot', got '${tone.loopMode}'`);
      }
      const patch = yield client.requestPatchData(sample.patchSlot);
      if (!patch) {
        errors.push(`Patch ${sample.patchSlot} not found on device`);
        continue;
      }
      const expectedToneSlot = sample.toneSlot;
      const toneLayer = patch.common.toneLayer1;
      const hasToneMapping = toneLayer.some((t) => t === expectedToneSlot);
      if (!hasToneMapping) {
        errors.push(`Patch ${sample.patchSlot}: doesn't map to tone ${expectedToneSlot}`);
      }
    }
    return {
      success: errors.length === 0,
      errors
    };
  });
}
function importMonolithicDrumKit(client, config, onProgress) {
  return __async(this, null, function* () {
    const {
      waveData,
      totalSampleCount,
      slices,
      sampleRate,
      startingToneSlot,
      waveBank,
      startingSegment,
      patchSlot,
      patchName,
      transpose = 0,
      velocitySensitivity = 2
    } = config;
    if (slices.length === 0) {
      throw new Error("Monolithic drum kit requires at least one slice");
    }
    const requiredToneSlots = slices.length + 1;
    if (requiredToneSlots > 32 - startingToneSlot) {
      throw new Error(`Not enough tone slots: need ${requiredToneSlots} (1 primary + ${slices.length} sub-tones), have ${32 - startingToneSlot}`);
    }
    console.log("[MonolithicDrumKit] Starting import");
    console.log(`  - Total samples: ${totalSampleCount}`);
    console.log(`  - Slices: ${slices.length}`);
    console.log(`  - Required tone slots: ${requiredToneSlots} (1 primary + ${slices.length} sub-tones)`);
    console.log(`  - Sample rate: ${sampleRate}`);
    console.log(`  - Starting tone slot: ${startingToneSlot}`);
    console.log(`  - Starting segment: ${startingSegment}`);
    const samplesPerSegment = 12e3;
    const segmentsNeeded = Math.ceil(totalSampleCount / samplesPerSegment);
    console.log(`  - Segments needed: ${segmentsNeeded}`);
    onProgress == null ? void 0 : onProgress(0, slices.length + 2, "Uploading wave data...");
    const primaryToneSlot = startingToneSlot;
    const primaryTone = createMonolithicPrimaryTone(
      {
        name: patchName.slice(0, 8),
        // Use patch name as it's the "holder"
        sampleRate,
        waveBank,
        segmentTop: startingSegment,
        segmentLength: segmentsNeeded,
        sampleCount: totalSampleCount,
        loopMode: "one-shot",
        originalKey: 60,
        // Default, not used since this tone isn't mapped
        transpose,
        pitchFollow: false,
        velocitySensitivity
      },
      0,
      // Start at beginning of wave
      totalSampleCount - 1
      // End at end of wave (full range, not used directly)
    );
    console.log("[MonolithicDrumKit] Primary (holder) tone created:");
    console.log(`  - Slot: ${primaryToneSlot}`);
    console.log(`  - Name: ${primaryTone.name}`);
    console.log(`  - origSubTone: ${primaryTone.origSubTone} (ORG - owns wave data)`);
    console.log(`  - Note: This tone is NOT mapped to any MIDI note`);
    yield client.importTone(
      {
        toneIndex: primaryToneSlot,
        waveData,
        waveBank,
        segmentTop: startingSegment,
        segmentLength: segmentsNeeded,
        tone: primaryTone
      },
      (bytesSent, totalBytes) => {
        const pct = totalBytes > 0 ? bytesSent / totalBytes : 0;
        onProgress == null ? void 0 : onProgress(pct, slices.length + 1, "Uploading wave data...");
      }
    );
    console.log("[MonolithicDrumKit] Primary tone uploaded");
    yield new Promise((resolve) => setTimeout(resolve, 1e3));
    const subTones = [];
    const subToneSlots = [];
    for (let i = 0; i < slices.length; i++) {
      const slice = slices[i];
      const toneSlot = startingToneSlot + 1 + i;
      onProgress == null ? void 0 : onProgress(i + 1, slices.length + 2, `Creating sub-tone ${slice.label}...`);
      const subTone = createSubTone({
        name: slice.label.slice(0, 8),
        sourceToneIndex: primaryToneSlot,
        sampleRate,
        startPoint: slice.startSample,
        endPoint: slice.endSample,
        loopMode: "one-shot",
        originalKey: slice.midiNote,
        transpose,
        pitchFollow: false,
        velocitySensitivity
      });
      console.log(`[MonolithicDrumKit] Sub-tone ${i} created:`);
      console.log(`  - Slot: ${toneSlot}`);
      console.log(`  - Name: ${subTone.name}`);
      console.log(`  - Source tone: ${subTone.sourceTone} (references primary)`);
      console.log(`  - origSubTone: ${subTone.origSubTone} (SUB)`);
      console.log(`  - Start point: ${subTone.wave.startPoint}`);
      console.log(`  - End point: ${subTone.wave.endPoint}`);
      console.log(`  - MIDI note: ${slice.midiNote}`);
      yield client.sendToneData(toneSlot, subTone);
      subTones.push(subTone);
      subToneSlots.push(toneSlot);
      yield new Promise((resolve) => setTimeout(resolve, 200));
    }
    onProgress == null ? void 0 : onProgress(slices.length + 1, slices.length + 2, `Creating patch ${patchName}...`);
    const toneMappings = slices.map((slice, i) => ({
      midiNote: slice.midiNote,
      toneSlot: startingToneSlot + 1 + i
      // +1 to skip primary
    }));
    const patch = createDrumKitPatch(patchName, toneMappings);
    yield client.sendPatchData(patchSlot, patch.common);
    console.log("[MonolithicDrumKit] Patch created");
    console.log(`  - Name: ${patchName}`);
    console.log(`  - Mappings: ${toneMappings.length}`);
    console.log(`  - Primary tone slot ${primaryToneSlot} is NOT mapped (wave holder only)`);
    onProgress == null ? void 0 : onProgress(slices.length + 2, slices.length + 2, "Import complete");
    return {
      primaryTone,
      primaryToneSlot,
      subTones,
      subToneSlots,
      patch,
      patchSlot,
      segmentsUsed: segmentsNeeded
    };
  });
}
export {
  ADDR_PATCH_BASE,
  ADDR_SYSTEM,
  ADDR_TONE_BASE,
  ADDR_WAVE_DATA,
  ARROW_CODES_CAT01,
  ARROW_CODES_CAT09,
  BULK_DUMP_TYPES2 as BULK_DUMP_TYPES,
  DEFAULT_DEVICE_ID2 as DEFAULT_DEVICE_ID,
  ERROR_CODES2 as ERROR_CODES,
  FRONT_PANEL_ADDRESS,
  FUNCTION_CODES,
  MAX_PATCHES,
  MAX_TONES,
  NAVIGATION_DELAY_MS,
  PATCH_COMMON_OFFSETS2 as PATCH_COMMON_OFFSETS,
  PATCH_PARAMS2 as PATCH_PARAMS,
  PATCH_TOTAL_SIZE2 as PATCH_TOTAL_SIZE,
  ROLAND_ID2 as ROLAND_ID,
  S330_ADDRESSES,
  S330_COMMANDS,
  S330_CONFIG,
  S330_DATA_TYPES,
  S330_FUNCTION_ADDRESSES,
  S330_MODEL_ID,
  SYSTEM_BLOCK_SIZE,
  SYSTEM_OFFSETS,
  TIMING2 as TIMING,
  TONE_BLOCK_NIBBLES2 as TONE_BLOCK_NIBBLES,
  TONE_BLOCK_SIZE2 as TONE_BLOCK_SIZE,
  TONE_LAYER_MAX_MIDI_NOTE,
  TONE_LAYER_MIN_MIDI_NOTE,
  TONE_LAYER_OFF,
  TONE_LAYER_SIZE,
  TONE_MAP_ENTRIES2 as TONE_MAP_ENTRIES,
  TONE_OFFSETS2 as TONE_OFFSETS,
  TONE_STRIDE,
  VALUE_CODES,
  VALUE_RANGES2 as VALUE_RANGES,
  buildACKMessage,
  buildDATMessage,
  buildDT1Message,
  buildEODMessage,
  buildERRMessage,
  buildFrontPanelMessage,
  buildPatchAddress2 as buildPatchAddress,
  buildPatchAddressRQD,
  buildPatchParamAddress2 as buildPatchParamAddress,
  buildRJCMessage,
  buildRQDMessage,
  buildSystemAddress2 as buildSystemAddress,
  buildToneAddress2 as buildToneAddress,
  buildWSDMessage,
  buildWaveDataAddress,
  calculateChecksum2 as calculateChecksum,
  calculateSegmentsNeeded,
  clamp7Bit,
  createDrumKitPatch,
  createDrumTone,
  createEmptyPatchCommon,
  createEmptyToneLayer,
  createFrontPanelController,
  createMonolithicPrimaryTone,
  createS330Client,
  createSubTone,
  createTone,
  createWav,
  denibblize,
  encode21BitAddress,
  encode24BitAddress,
  encodeAftertouchAssign,
  encodeEgPolarity,
  encodeEnvelope,
  encodeKeyAssign,
  encodeKeyMode,
  encodeLfoMode,
  encodeLoopMode,
  encodeName,
  encodePatchCommon,
  encodeSampleRate,
  encodeSignedValue,
  encodeSize,
  encodeSystemParams,
  encodeTone,
  getToneAtMidiNote,
  importDrumKit,
  importMonolithicDrumKit,
  isArrowButton,
  isDT1Message,
  isNavigationButton,
  isUIStateAddress,
  isValid7BitValue,
  isValidDeviceId,
  isValidMidiChannel,
  isValidPatchNumber,
  isValidToneLayerMidiNote,
  isValidToneNumber,
  isValueButton,
  layerIndexToMidiNote,
  midiNoteToLayerIndex,
  nibblize,
  parse21BitAddress,
  parse24BitAddress,
  parseAftertouchAssign,
  parseDT1Message,
  parseEgPolarity,
  parseEnvelope,
  parseKeyAssign,
  parseKeyMode,
  parseLevelCurve,
  parseLfoMode,
  parseLoopMode,
  parseName,
  parsePatchCommon,
  parseSampleRate,
  parseSignedValue,
  parseSystemParams,
  parseTone,
  parseWav,
  prepareWavForS330,
  resample,
  s330ToWav,
  sampleRateLabelToHz,
  setToneAtMidiNote,
  setToneForMidiRange,
  toneLayerToZones,
  toneSampleRateHz,
  validateWaveDataFits,
  verifyDrumKitImport,
  wavToS330,
  zonesToToneLayer
};
//# sourceMappingURL=s330.js.map